import React, {createRef} from 'react';
import Typography from "@material-ui/core/Typography";
import {
    imsAuditChecklist, imsAuditChecklistRevision,
    addImsAuditChecklistRevision, saveOrUpdateImsAuditChecklist,
} from "../../util/ImsAuditChecklistApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {Spinner} from "../common/Spinner";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, ExpandMoreTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Grid from "@material-ui/core/Grid";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import {BlueButton, GreenButton, OrangeButton} from "../common/ButtonsConstants";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import ImsAuditChecklistRow from "./ImsAuditChecklistRow";
import {ACCESS_TOKEN, BOUND_USER_ID, V1_API_URL_PREFIX} from "../../Constants";
import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import * as CommonUtils from "../../util/CommonUtils";
import TableComponent from "../common/TableComponent";
import {deleteDocumentRetention} from "../../util/OperationModuleApiUtils";
import ImsAuditChecklistHeader from "./ImsAuditChecklistHeader";

const classes = ((theme) => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
        width: "100%",
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));


const columns = [
    {
        title: 'id',
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    {
        name: 'Audit Dates',
        id: 'displayDate',
        type: "text"
    },
    {
        name: 'Audit Scope',
        id: 'scope',
        type: "text",
    },
    {
        name: 'Auditor',
        id: 'auditor',
        type: "text",
    },
    {
        name: 'Location',
        id: 'location',
        type: "text",
    },
    {
        name: 'Auditee',
        id: 'auditee',
        type: "text",
    },
];

class ImsAuditChecklist extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imsAuditChecklist: {},
            isLoading: true,
            isAutosaveRunning: false,
        };
        this.loadImsAuditChecklist = this.loadImsAuditChecklist.bind(this);
        this.saveImsAuditChecklist = this.saveImsAuditChecklist.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onYearSelected = this.onYearSelected.bind(this);
        this.exportReport = this.exportReport.bind(this);
        this.exportSingleReport = this.exportSingleReport.bind(this);
        this.editImsAuditChecklist = this.editImsAuditChecklist.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onChange() {
        if (!this.state.isAutosaveRunning) {
            this.setState({
                ...this.state, isAutosaveRunning: true
            });
            setTimeout(() => {
                const updateRequest = this.captureFromFrontEnd();
                saveOrUpdateImsAuditChecklist(updateRequest);
                this.setState({
                    ...this.state, isAutosaveRunning: false
                });
            }, 300000);
            //clearTimeout(this.timer.current);
        }
    }

    componentDidMount() {
        const selectedYear = moment(new Date()).format('YYYY');
        this.setState({
            selectedYear: selectedYear,
        });
        this.loadImsAuditChecklist(selectedYear);
    }

    handleChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    handleSave(event) {
        event.preventDefault();
        const updateRequest = this.captureFromFrontEnd();
        saveOrUpdateImsAuditChecklist(updateRequest)
            .then(() => {
                this.setState({
                    isEditing: false,
                    isAutosaveRunning: false,
                }, () => this.loadImsAuditChecklist(this.state.selectedYear));
                NotificationManager.success('Success', 'The Ims Audit Checklist details have been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    editImsAuditChecklist() {
        this.setState({
            isEditing: true,
        });
    }

    showModal() {
        this.setState({ show: true });
    }

    addRevision(request) {
        addImsAuditChecklistRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    onYearSelected(event, selectedYear) {
        this.setState({
            selectedYear: selectedYear,
            isLoading: true,
        });
        this.loadImsAuditChecklist(selectedYear);
    }

    loadImsAuditChecklist(selectedYear) {
        console.log('with selected year ' + selectedYear);
        imsAuditChecklist()
            .then(response => {
                console.log('response', response);
                let imsChecklist = response.filter(function(imsAuditChecklist) {
                    console.log('imsAuditChecklist.approvedYear === selectedYear ' + (imsAuditChecklist.approvedYear === parseInt(selectedYear)));
                    return imsAuditChecklist.approvedYear === parseInt(selectedYear);
                });
                console.log('using imsChecklist', imsChecklist);
                this.setState({
                    isEditing: false,
                    imsAuditChecklist: imsChecklist,
                    imsChecklist: imsChecklist[0],
                    id: imsChecklist[0] ? imsChecklist[0].id : null,
                    scope: imsChecklist[0] ? imsChecklist[0].scope : "",
                    location: imsChecklist[0] ? imsChecklist[0].location : "",
                    auditor: imsChecklist[0] ? imsChecklist[0].auditor : "",
                    date1: imsChecklist[0] ? imsChecklist[0].date1 : "",
                    date2: imsChecklist[0] ? imsChecklist[0].date2 : "",
                    date3: imsChecklist[0] ? imsChecklist[0].date3 : "",
                    date4: imsChecklist[0] ? imsChecklist[0].date4 : "",
                    auditee: imsChecklist[0] ? imsChecklist[0].auditee : "",
                    displayDate: imsChecklist[0] ? imsChecklist[0].displayDate : "",
                    evidence1: imsChecklist[0] ? imsChecklist[0].evidence1 : "",
                    finding1: imsChecklist[0] ? imsChecklist[0].finding1 : "",
                    evidence2: imsChecklist[0] ? imsChecklist[0].evidence2 : "",
                    finding2: imsChecklist[0] ? imsChecklist[0].finding2 : "",
                    evidence3: imsChecklist[0] ? imsChecklist[0].evidence3 : "",
                    finding3: imsChecklist[0] ? imsChecklist[0].finding3 : "",
                    evidence4: imsChecklist[0] ? imsChecklist[0].evidence4 : "",
                    finding4: imsChecklist[0] ? imsChecklist[0].finding4 : "",
                    evidence5: imsChecklist[0] ? imsChecklist[0].evidence5 : "",
                    finding5: imsChecklist[0] ? imsChecklist[0].finding5 : "",
                    evidence6: imsChecklist[0] ? imsChecklist[0].evidence6 : "",
                    finding6: imsChecklist[0] ? imsChecklist[0].finding6 : "",
                    evidence7: imsChecklist[0] ? imsChecklist[0].evidence7 : "",
                    finding7: imsChecklist[0] ? imsChecklist[0].finding7 : "",
                    evidence8: imsChecklist[0] ? imsChecklist[0].evidence8 : "",
                    finding8: imsChecklist[0] ? imsChecklist[0].finding8 : "",
                    evidence9: imsChecklist[0] ? imsChecklist[0].evidence9 : "",
                    finding9: imsChecklist[0] ? imsChecklist[0].finding9 : "",
                    evidence10: imsChecklist[0] ? imsChecklist[0].evidence10 : "",
                    finding10: imsChecklist[0] ? imsChecklist[0].finding10 : "",
                    evidence11: imsChecklist[0] ? imsChecklist[0].evidence11 : "",
                    finding11: imsChecklist[0] ? imsChecklist[0].finding11 : "",
                    evidence12: imsChecklist[0] ? imsChecklist[0].evidence12 : "",
                    finding12: imsChecklist[0] ? imsChecklist[0].finding12 : "",
                    evidence13: imsChecklist[0] ? imsChecklist[0].evidence13 : "",
                    finding13: imsChecklist[0] ? imsChecklist[0].finding13 : "",
                    evidence14: imsChecklist[0] ? imsChecklist[0].evidence14 : "",
                    finding14: imsChecklist[0] ? imsChecklist[0].finding14 : "",
                    evidence15: imsChecklist[0] ? imsChecklist[0].evidence15 : "",
                    finding15: imsChecklist[0] ? imsChecklist[0].finding15 : "",
                    evidence16: imsChecklist[0] ? imsChecklist[0].evidence16 : "",
                    finding16: imsChecklist[0] ? imsChecklist[0].finding16 : "",
                    evidence17: imsChecklist[0] ? imsChecklist[0].evidence17 : "",
                    finding17: imsChecklist[0] ? imsChecklist[0].finding17 : "",
                    evidence18: imsChecklist[0] ? imsChecklist[0].evidence18 : "",
                    finding18: imsChecklist[0] ? imsChecklist[0].finding18 : "",
                    evidence19: imsChecklist[0] ? imsChecklist[0].evidence19 : "",
                    finding19: imsChecklist[0] ? imsChecklist[0].finding19 : "",
                    evidence20: imsChecklist[0] ? imsChecklist[0].evidence20 : "",
                    finding20: imsChecklist[0] ? imsChecklist[0].finding20 : "",
                    evidence21: imsChecklist[0] ? imsChecklist[0].evidence21 : "",
                    finding21: imsChecklist[0] ? imsChecklist[0].finding21 : "",
                    evidence22: imsChecklist[0] ? imsChecklist[0].evidence22 : "",
                    finding22: imsChecklist[0] ? imsChecklist[0].finding22 : "",
                    evidence23: imsChecklist[0] ? imsChecklist[0].evidence23 : "",
                    finding23: imsChecklist[0] ? imsChecklist[0].finding23 : "",
                    evidence24: imsChecklist[0] ? imsChecklist[0].evidence24 : "",
                    finding24: imsChecklist[0] ? imsChecklist[0].finding24 : "",
                    evidence25: imsChecklist[0] ? imsChecklist[0].evidence25 : "",
                    finding25: imsChecklist[0] ? imsChecklist[0].finding25 : "",
                    evidence26: imsChecklist[0] ? imsChecklist[0].evidence26 : "",
                    finding26: imsChecklist[0] ? imsChecklist[0].finding26 : "",
                    evidence27: imsChecklist[0] ? imsChecklist[0].evidence27 : "",
                    finding27: imsChecklist[0] ? imsChecklist[0].finding27 : "",
                    evidence28: imsChecklist[0] ? imsChecklist[0].evidence28 : "",
                    finding28: imsChecklist[0] ? imsChecklist[0].finding28 : "",
                    evidence29: imsChecklist[0] ? imsChecklist[0].evidence29 : "",
                    finding29: imsChecklist[0] ? imsChecklist[0].finding29 : "",
                    evidence30: imsChecklist[0] ? imsChecklist[0].evidence30 : "",
                    finding30: imsChecklist[0] ? imsChecklist[0].finding30 : "",
                    evidence31: imsChecklist[0] ? imsChecklist[0].evidence31 : "",
                    finding31: imsChecklist[0] ? imsChecklist[0].finding31 : "",
                    evidence32: imsChecklist[0] ? imsChecklist[0].evidence32 : "",
                    finding32: imsChecklist[0] ? imsChecklist[0].finding32 : "",
                    evidence33: imsChecklist[0] ? imsChecklist[0].evidence33 : "",
                    finding33: imsChecklist[0] ? imsChecklist[0].finding33 : "",
                    evidence34: imsChecklist[0] ? imsChecklist[0].evidence34 : "",
                    finding34: imsChecklist[0] ? imsChecklist[0].finding34 : "",
                    evidence35: imsChecklist[0] ? imsChecklist[0].evidence35 : "",
                    finding35: imsChecklist[0] ? imsChecklist[0].finding35 : "",
                    evidence36: imsChecklist[0] ? imsChecklist[0].evidence36 : "",
                    finding36: imsChecklist[0] ? imsChecklist[0].finding36 : "",
                    evidence37: imsChecklist[0] ? imsChecklist[0].evidence37 : "",
                    finding37: imsChecklist[0] ? imsChecklist[0].finding37 : "",
                    evidence38: imsChecklist[0] ? imsChecklist[0].evidence38 : "",
                    finding38: imsChecklist[0] ? imsChecklist[0].finding38 : "",
                    evidence39: imsChecklist[0] ? imsChecklist[0].evidence39 : "",
                    finding39: imsChecklist[0] ? imsChecklist[0].finding39 : "",
                    evidence40: imsChecklist[0] ? imsChecklist[0].evidence40 : "",
                    finding40: imsChecklist[0] ? imsChecklist[0].finding40 : "",
                    evidence41: imsChecklist[0] ? imsChecklist[0].evidence41 : "",
                    finding41: imsChecklist[0] ? imsChecklist[0].finding41 : "",
                    evidence42: imsChecklist[0] ? imsChecklist[0].evidence42 : "",
                    finding42: imsChecklist[0] ? imsChecklist[0].finding42 : "",
                    evidence43: imsChecklist[0] ? imsChecklist[0].evidence43 : "",
                    finding43: imsChecklist[0] ? imsChecklist[0].finding43 : "",
                    evidence44: imsChecklist[0] ? imsChecklist[0].evidence44 : "",
                    finding44: imsChecklist[0] ? imsChecklist[0].finding44 : "",
                    evidence45: imsChecklist[0] ? imsChecklist[0].evidence45 : "",
                    finding45: imsChecklist[0] ? imsChecklist[0].finding45 : "",
                    evidence46: imsChecklist[0] ? imsChecklist[0].evidence46 : "",
                    finding46: imsChecklist[0] ? imsChecklist[0].finding46 : "",
                    evidence47: imsChecklist[0] ? imsChecklist[0].evidence47 : "",
                    finding47: imsChecklist[0] ? imsChecklist[0].finding47 : "",
                    evidence48: imsChecklist[0] ? imsChecklist[0].evidence48 : "",
                    finding48: imsChecklist[0] ? imsChecklist[0].finding48 : "",
                    evidence49: imsChecklist[0] ? imsChecklist[0].evidence49 : "",
                    finding49: imsChecklist[0] ? imsChecklist[0].finding49 : "",
                    evidence50: imsChecklist[0] ? imsChecklist[0].evidence50 : "",
                    finding50: imsChecklist[0] ? imsChecklist[0].finding50 : "",
                    evidence51: imsChecklist[0] ? imsChecklist[0].evidence51 : "",
                    finding51: imsChecklist[0] ? imsChecklist[0].finding51 : "",
                    evidence52: imsChecklist[0] ? imsChecklist[0].evidence52 : "",
                    finding52: imsChecklist[0] ? imsChecklist[0].finding52 : "",
                    evidence53: imsChecklist[0] ? imsChecklist[0].evidence53 : "",
                    finding53: imsChecklist[0] ? imsChecklist[0].finding53 : "",
                    evidence54: imsChecklist[0] ? imsChecklist[0].evidence54 : "",
                    finding54: imsChecklist[0] ? imsChecklist[0].finding54 : "",
                    evidence55: imsChecklist[0] ? imsChecklist[0].evidence55 : "",
                    finding55: imsChecklist[0] ? imsChecklist[0].finding55 : "",
                    evidence56: imsChecklist[0] ? imsChecklist[0].evidence56 : "",
                    finding56: imsChecklist[0] ? imsChecklist[0].finding56 : "",
                    evidence57: imsChecklist[0] ? imsChecklist[0].evidence57 : "",
                    finding57: imsChecklist[0] ? imsChecklist[0].finding57 : "",
                    evidence59: imsChecklist[0] ? imsChecklist[0].evidence59 : "",
                    finding59: imsChecklist[0] ? imsChecklist[0].finding59 : "",
                    evidence60: imsChecklist[0] ? imsChecklist[0].evidence60 : "",
                    finding60: imsChecklist[0] ? imsChecklist[0].finding60 : "",
                    evidence64: imsChecklist[0] ? imsChecklist[0].evidence64 : "",
                    finding64: imsChecklist[0] ? imsChecklist[0].finding64 : "",
                    evidence65: imsChecklist[0] ? imsChecklist[0].evidence65 : "",
                    finding65: imsChecklist[0] ? imsChecklist[0].finding65 : "",
                    evidence66: imsChecklist[0] ? imsChecklist[0].evidence66 : "",
                    finding66: imsChecklist[0] ? imsChecklist[0].finding66 : "",
                    evidence67: imsChecklist[0] ? imsChecklist[0].evidence67 : "",
                    finding67: imsChecklist[0] ? imsChecklist[0].finding67 : "",
                    evidence68: imsChecklist[0] ? imsChecklist[0].evidence68 : "",
                    finding68: imsChecklist[0] ? imsChecklist[0].finding68 : "",
                    evidence69: imsChecklist[0] ? imsChecklist[0].evidence69 : "",
                    finding69: imsChecklist[0] ? imsChecklist[0].finding69 : "",
                    evidence70: imsChecklist[0] ? imsChecklist[0].evidence70 : "",
                    finding70: imsChecklist[0] ? imsChecklist[0].finding70 : "",
                    evidence71: imsChecklist[0] ? imsChecklist[0].evidence71 : "",
                    finding71: imsChecklist[0] ? imsChecklist[0].finding71 : "",
                    evidence72: imsChecklist[0] ? imsChecklist[0].evidence72 : "",
                    finding72: imsChecklist[0] ? imsChecklist[0].finding72 : "",
                    evidence73: imsChecklist[0] ? imsChecklist[0].evidence73 : "",
                    finding73: imsChecklist[0] ? imsChecklist[0].finding73 : "",
                    evidence74: imsChecklist[0] ? imsChecklist[0].evidence74 : "",
                    finding74: imsChecklist[0] ? imsChecklist[0].finding74 : "",
                    evidence75: imsChecklist[0] ? imsChecklist[0].evidence75 : "",
                    finding75: imsChecklist[0] ? imsChecklist[0].finding75 : "",
                    evidence76: imsChecklist[0] ? imsChecklist[0].evidence76 : "",
                    finding76: imsChecklist[0] ? imsChecklist[0].finding76 : "",
                    evidence77: imsChecklist[0] ? imsChecklist[0].evidence77 : "",
                    finding77: imsChecklist[0] ? imsChecklist[0].finding77 : "",
                    evidence78: imsChecklist[0] ? imsChecklist[0].evidence78 : "",
                    finding78: imsChecklist[0] ? imsChecklist[0].finding78 : "",
                    evidence79: imsChecklist[0] ? imsChecklist[0].evidence79 : "",
                    finding79: imsChecklist[0] ? imsChecklist[0].finding79 : "",
                    evidence80: imsChecklist[0] ? imsChecklist[0].evidence80 : "",
                    finding80: imsChecklist[0] ? imsChecklist[0].finding80 : "",
                    evidence81: imsChecklist[0] ? imsChecklist[0].evidence81 : "",
                    finding81: imsChecklist[0] ? imsChecklist[0].finding81 : "",
                    evidence82: imsChecklist[0] ? imsChecklist[0].evidence82 : "",
                    finding82: imsChecklist[0] ? imsChecklist[0].finding82 : "",
                    evidence83: imsChecklist[0] ? imsChecklist[0].evidence83 : "",
                    finding83: imsChecklist[0] ? imsChecklist[0].finding83 : "",
                    evidence84: imsChecklist[0] ? imsChecklist[0].evidence84 : "",
                    finding84: imsChecklist[0] ? imsChecklist[0].finding84 : "",
                    evidence85: imsChecklist[0] ? imsChecklist[0].evidence85 : "",
                    finding85: imsChecklist[0] ? imsChecklist[0].finding85 : "",
                    evidence86: imsChecklist[0] ? imsChecklist[0].evidence86 : "",
                    finding86: imsChecklist[0] ? imsChecklist[0].finding86 : "",
                    evidence87: imsChecklist[0] ? imsChecklist[0].evidence87 : "",
                    finding87: imsChecklist[0] ? imsChecklist[0].finding87 : "",
                    evidence88: imsChecklist[0] ? imsChecklist[0].evidence88 : "",
                    finding88: imsChecklist[0] ? imsChecklist[0].finding88 : "",
                    evidence89: imsChecklist[0] ? imsChecklist[0].evidence89 : "",
                    finding89: imsChecklist[0] ? imsChecklist[0].finding89 : "",
                    evidence90: imsChecklist[0] ? imsChecklist[0].evidence90 : "",
                    finding90: imsChecklist[0] ? imsChecklist[0].finding90 : "",
                    evidence91: imsChecklist[0] ? imsChecklist[0].evidence91 : "",
                    finding91: imsChecklist[0] ? imsChecklist[0].finding91 : "",
                    evidence92: imsChecklist[0] ? imsChecklist[0].evidence92 : "",
                    finding92: imsChecklist[0] ? imsChecklist[0].finding92 : "",
                    evidence93: imsChecklist[0] ? imsChecklist[0].evidence93 : "",
                    finding93: imsChecklist[0] ? imsChecklist[0].finding93 : "",
                    evidence94: imsChecklist[0] ? imsChecklist[0].evidence94 : "",
                    finding94: imsChecklist[0] ? imsChecklist[0].finding94 : "",
                    evidence95: imsChecklist[0] ? imsChecklist[0].evidence95 : "",
                    finding95: imsChecklist[0] ? imsChecklist[0].finding95 : "",
                    evidence96: imsChecklist[0] ? imsChecklist[0].evidence96 : "",
                    finding96: imsChecklist[0] ? imsChecklist[0].finding96 : "",
                    evidence97: imsChecklist[0] ? imsChecklist[0].evidence97 : "",
                    finding97: imsChecklist[0] ? imsChecklist[0].finding97 : "",
                    evidence98: imsChecklist[0] ? imsChecklist[0].evidence98 : "",
                    finding98: imsChecklist[0] ? imsChecklist[0].finding98 : "",
                    evidence99: imsChecklist[0] ? imsChecklist[0].evidence99 : "",
                    finding99: imsChecklist[0] ? imsChecklist[0].finding99 : "",
                    evidence100: imsChecklist[0] ? imsChecklist[0].evidence100 : "",
                    finding100: imsChecklist[0] ? imsChecklist[0].finding100 : "",
                    evidence101: imsChecklist[0] ? imsChecklist[0].evidence101 : "",
                    finding101: imsChecklist[0] ? imsChecklist[0].finding101 : "",
                    evidence102: imsChecklist[0] ? imsChecklist[0].evidence102 : "",
                    finding102: imsChecklist[0] ? imsChecklist[0].finding102 : "",
                    evidence103: imsChecklist[0] ? imsChecklist[0].evidence103 : "",
                    finding103: imsChecklist[0] ? imsChecklist[0].finding103 : "",
                    evidence104: imsChecklist[0] ? imsChecklist[0].evidence104 : "",
                    finding104: imsChecklist[0] ? imsChecklist[0].finding104 : "",
                    evidence105: imsChecklist[0] ? imsChecklist[0].evidence105 : "",
                    finding105: imsChecklist[0] ? imsChecklist[0].finding105 : "",
                    evidence106: imsChecklist[0] ? imsChecklist[0].evidence106 : "",
                    finding106: imsChecklist[0] ? imsChecklist[0].finding106 : "",
                    evidence107: imsChecklist[0] ? imsChecklist[0].evidence107 : "",
                    finding107: imsChecklist[0] ? imsChecklist[0].finding107 : "",
                    evidence108: imsChecklist[0] ? imsChecklist[0].evidence108 : "",
                    finding108: imsChecklist[0] ? imsChecklist[0].finding108 : "",
                    evidence109: imsChecklist[0] ? imsChecklist[0].evidence109 : "",
                    finding109: imsChecklist[0] ? imsChecklist[0].finding109 : "",
                    evidence110: imsChecklist[0] ? imsChecklist[0].evidence110 : "",
                    finding110: imsChecklist[0] ? imsChecklist[0].finding110 : "",
                    evidence111: imsChecklist[0] ? imsChecklist[0].evidence111 : "",
                    finding111: imsChecklist[0] ? imsChecklist[0].finding111 : "",
                    evidence112: imsChecklist[0] ? imsChecklist[0].evidence112 : "",
                    finding112: imsChecklist[0] ? imsChecklist[0].finding112 : "",
                    evidence113: imsChecklist[0] ? imsChecklist[0].evidence113 : "",
                    finding113: imsChecklist[0] ? imsChecklist[0].finding113 : "",
                    evidence114: imsChecklist[0] ? imsChecklist[0].evidence114 : "",
                    finding114: imsChecklist[0] ? imsChecklist[0].finding114 : "",
                    evidence115: imsChecklist[0] ? imsChecklist[0].evidence115 : "",
                    finding115: imsChecklist[0] ? imsChecklist[0].finding115 : "",
                    evidence116: imsChecklist[0] ? imsChecklist[0].evidence116 : "",
                    finding116: imsChecklist[0] ? imsChecklist[0].finding116 : "",
                    evidence117: imsChecklist[0] ? imsChecklist[0].evidence117 : "",
                    finding117: imsChecklist[0] ? imsChecklist[0].finding117 : "",
                    evidence118: imsChecklist[0] ? imsChecklist[0].evidence118 : "",
                    finding118: imsChecklist[0] ? imsChecklist[0].finding118 : "",
                    evidence125: imsChecklist[0] ? imsChecklist[0].evidence125 : "",
                    finding125: imsChecklist[0] ? imsChecklist[0].finding125 : "",
                    evidence126: imsChecklist[0] ? imsChecklist[0].evidence126 : "",
                    finding126: imsChecklist[0] ? imsChecklist[0].finding126 : "",
                    evidence128: imsChecklist[0] ? imsChecklist[0].evidence128 : "",
                    finding128: imsChecklist[0] ? imsChecklist[0].finding128 : "",
                    evidence129: imsChecklist[0] ? imsChecklist[0].evidence129 : "",
                    finding129: imsChecklist[0] ? imsChecklist[0].finding129 : "",
                    evidence130: imsChecklist[0] ? imsChecklist[0].evidence130 : "",
                    finding130: imsChecklist[0] ? imsChecklist[0].finding130 : "",
                    evidence131: imsChecklist[0] ? imsChecklist[0].evidence131 : "",
                    finding131: imsChecklist[0] ? imsChecklist[0].finding131 : "",
                    evidence132: imsChecklist[0] ? imsChecklist[0].evidence132 : "",
                    finding132: imsChecklist[0] ? imsChecklist[0].finding132 : "",
                    evidence133: imsChecklist[0] ? imsChecklist[0].evidence133 : "",
                    finding133: imsChecklist[0] ? imsChecklist[0].finding133 : "",
                    evidence134: imsChecklist[0] ? imsChecklist[0].evidence134 : "",
                    finding134: imsChecklist[0] ? imsChecklist[0].finding134 : "",
                    evidence135: imsChecklist[0] ? imsChecklist[0].evidence135 : "",
                    finding135: imsChecklist[0] ? imsChecklist[0].finding135 : "",
                    evidence136: imsChecklist[0] ? imsChecklist[0].evidence136 : "",
                    finding136: imsChecklist[0] ? imsChecklist[0].finding136 : "",
                    evidence137: imsChecklist[0] ? imsChecklist[0].evidence137 : "",
                    finding137: imsChecklist[0] ? imsChecklist[0].finding137 : "",
                    evidence138: imsChecklist[0] ? imsChecklist[0].evidence138 : "",
                    finding138: imsChecklist[0] ? imsChecklist[0].finding138 : "",
                });
                imsAuditChecklistRevision()
                    .then(response => {
                        this.setState({
                            latestRevision: response,
                            isLoading: false,
                        });
                    })
                    .catch(error => {
                        console.log(error);
                    });
            })
            .catch(error => {
                console.log(error);
            });
    }

    captureFromFrontEnd() {
        const {
            evidence1, finding1, evidence2, finding2, evidence3, finding3, evidence4, finding4, evidence5, finding5,
            evidence6, finding6, evidence7, finding7, evidence8, finding8, evidence9, finding9, evidence10, finding10,
            evidence11, finding11, evidence12, finding12, evidence13, finding13, evidence14, finding14, evidence15, finding15,
            evidence16, finding16, evidence17, finding17, evidence18, finding18, evidence19, finding19, evidence20, finding20,
            evidence21, finding21, evidence22, finding22, evidence23, finding23, evidence24, finding24, evidence25, finding25,
            evidence26, finding26, evidence27, finding27, evidence28, finding28, evidence29, finding29, evidence30, finding30,
            evidence31, finding31, evidence32, finding32, evidence33, finding33, evidence34, finding34, evidence35, finding35,
            evidence36, finding36, evidence37, finding37, evidence38, finding38, evidence39, finding39, evidence40, finding40,
            evidence41, finding41, evidence42, finding42, evidence43, finding43, evidence44, finding44, evidence45, finding45,
            evidence46, finding46, evidence47, finding47, evidence48, finding48, evidence49, finding49, evidence50, finding50,
            evidence51, finding51, evidence52, finding52, evidence53, finding53, evidence54, finding54, evidence55, finding55,
            evidence56, finding56, evidence57, finding57, evidence59, finding59, evidence60, finding60,
            evidence64, finding64, evidence65, finding65,
            evidence66, finding66, evidence67, finding67, evidence68, finding68, evidence69, finding69, evidence70, finding70,
            evidence71, finding71, evidence72, finding72, evidence73, finding73, evidence74, finding74, evidence75, finding75,
            evidence76, finding76, evidence77, finding77, evidence78, finding78, evidence79, finding79, evidence80, finding80,
            evidence81, finding81, evidence82, finding82, evidence83, finding83, evidence84, finding84, evidence85, finding85,
            evidence86, finding86, evidence87, finding87, evidence88, finding88, evidence89, finding89, evidence90, finding90,
            evidence91, finding91, evidence92, finding92, evidence93, finding93, evidence94, finding94, evidence95, finding95,
            evidence96, finding96, evidence97, finding97, evidence98, finding98, evidence99, finding99, evidence100, finding100,
            evidence101, finding101, evidence102, finding102, evidence103, finding103, evidence104, finding104, evidence105, finding105,
            evidence106, finding106, evidence107, finding107, evidence108, finding108, evidence109, finding109, evidence110, finding110,
            evidence111, finding111, evidence112, finding112, evidence113, finding113, evidence114, finding114, evidence115, finding115,
            evidence116, finding116, evidence117, finding117, evidence118, finding118, evidence125, finding125,
            evidence126, finding126, evidence128, finding128, evidence129, finding129, evidence130, finding130,
            evidence131, finding131, evidence132, finding132, evidence133, finding133, evidence134, finding134, evidence135, finding135,
            evidence136, finding136, evidence137, finding137, evidence138, finding138,
            location, date1, date2, date3, date4, scope, auditor, auditee
        } = this.form;

        console.log('this.state.selectedYear', this.state.selectedYear);
        let request = {};
        request.id = this.state.id;
        request.finding1 = finding1.value;
        request.evidence1 = evidence1.value;
        request.finding2 = finding2.value;
        request.evidence2 = evidence2.value;
        request.finding3 = finding3.value;
        request.evidence3 = evidence3.value;
        request.finding4 = finding4.value;
        request.evidence4 = evidence4.value;
        request.finding5 = finding5.value;
        request.evidence5 = evidence5.value;
        request.finding6 = finding6.value;
        request.evidence6 = evidence6.value;
        request.finding7 = finding7.value;
        request.evidence7 = evidence7.value;
        request.finding8 = finding8.value;
        request.evidence8 = evidence8.value;
        request.finding9 = finding9.value;
        request.evidence9 = evidence9.value;
        request.evidence10 = evidence10.value;
        request.finding10 = finding10.value;
        request.evidence11 = evidence11.value;
        request.finding11 = finding11.value;
        request.evidence13 = evidence13.value;
        request.finding13 = finding13.value;
        request.evidence14 = evidence14.value;
        request.finding14 = finding14.value;
        request.evidence15 = evidence15.value;
        request.finding15 = finding15.value;
        request.evidence16 = evidence16.value;
        request.finding16 = finding16.value;
        request.evidence17 = evidence17.value;
        request.finding17 = finding17.value;
        request.evidence18 = evidence18.value;
        request.finding18 = finding18.value;
        request.evidence19 = evidence19.value;
        request.finding19 = finding19.value;
        request.evidence20 = evidence20.value;
        request.finding20 = finding20.value;
        request.evidence21 = evidence21.value;
        request.finding21 = finding21.value;
        request.evidence22 = evidence22.value;
        request.finding22 = finding22.value;
        request.evidence23 = evidence23.value;
        request.finding23 = finding23.value;
        request.evidence24 = evidence24.value;
        request.finding24 = finding24.value;
        request.evidence25 = evidence25.value;
        request.finding25 = finding25.value;
        request.evidence26 = evidence26.value;
        request.finding26 = finding26.value;
        request.evidence27 = evidence27.value;
        request.finding27 = finding27.value;
        request.evidence28 = evidence28.value;
        request.finding28 = finding28.value;
        request.evidence29 = evidence29.value;
        request.finding29 = finding29.value;
        request.evidence30 = evidence30.value;
        request.finding30 = finding30.value;
        request.evidence31 = evidence31.value;
        request.finding31 = finding31.value;
        request.evidence32 = evidence32.value;
        request.finding32 = finding32.value;
        request.evidence33 = evidence33.value;
        request.finding33 = finding33.value;
        request.evidence34 = evidence34.value;
        request.finding34 = finding34.value;
        request.evidence35 = evidence35.value;
        request.finding35 = finding35.value;
        request.evidence36 = evidence36.value;
        request.finding36 = finding36.value;
        request.evidence37 = evidence37.value;
        request.finding37 = finding37.value;
        request.evidence38 = evidence38.value;
        request.finding38 = finding38.value;
        request.evidence39 = evidence39.value;
        request.finding39 = finding39.value;
        request.evidence40 = evidence40.value;
        request.finding40 = finding40.value;
        request.evidence41 = evidence41.value;
        request.finding41 = finding41.value;
        request.evidence42 = evidence42.value;
        request.finding42 = finding42.value;
        request.evidence43 = evidence43.value;
        request.finding43 = finding43.value;
        request.evidence44 = evidence44.value;
        request.finding44 = finding44.value;
        request.evidence45 = evidence45.value;
        request.finding45 = finding45.value;
        request.evidence46 = evidence46.value;
        request.finding46 = finding46.value;
        request.evidence47 = evidence47.value;
        request.finding47 = finding47.value;
        request.evidence48 = evidence48.value;
        request.finding48 = finding48.value;
        request.evidence49 = evidence49.value;
        request.finding49 = finding49.value;
        request.evidence50 = evidence50.value;
        request.finding50 = finding50.value;
        request.evidence51 = evidence51.value;
        request.finding51 = finding51.value;
        request.evidence52 = evidence52.value;
        request.finding52 = finding52.value;
        request.evidence53 = evidence53.value;
        request.finding53 = finding53.value;
        request.evidence54 = evidence54.value;
        request.finding54 = finding54.value;
        request.evidence55 = evidence55.value;
        request.finding55 = finding55.value;
        request.evidence56 = evidence56.value;
        request.finding56 = finding56.value;
        request.evidence57 = evidence57.value;
        request.finding57 = finding57.value;
        request.evidence59 = evidence59.value;
        request.finding59 = finding59.value;
        request.evidence60 = evidence60.value;
        request.finding60 = finding60.value;
        request.evidence64 = evidence64.value;
        request.finding64 = finding64.value;
        request.evidence65 = evidence65.value;
        request.finding65 = finding65.value;
        request.evidence66 = evidence66.value;
        request.finding66 = finding66.value;
        request.evidence67 = evidence67.value;
        request.finding67 = finding67.value;
        request.evidence68 = evidence68.value;
        request.finding68 = finding68.value;
        request.evidence69 = evidence69.value;
        request.finding69 = finding69.value;
        request.evidence70 = evidence70.value;
        request.finding70 = finding70.value;
        request.evidence71 = evidence71.value;
        request.finding71 = finding71.value;
        request.evidence72 = evidence72.value;
        request.finding72 = finding72.value;
        request.evidence73 = evidence73.value;
        request.finding73 = finding73.value;
        request.evidence74 = evidence74.value;
        request.finding74 = finding74.value;
        request.evidence75 = evidence75.value;
        request.finding75 = finding75.value;
        request.evidence76 = evidence76.value;
        request.finding76 = finding76.value;
        request.evidence77 = evidence77.value;
        request.finding77 = finding77.value;
        request.evidence78 = evidence78.value;
        request.finding78 = finding78.value;
        request.evidence79 = evidence79.value;
        request.finding79 = finding79.value;
        request.evidence80 = evidence80.value;
        request.finding80 = finding80.value;
        request.evidence81 = evidence81.value;
        request.finding81 = finding81.value;
        request.evidence82 = evidence82.value;
        request.finding82 = finding82.value;
        request.evidence83 = evidence83.value;
        request.finding83 = finding83.value;
        request.evidence84 = evidence84.value;
        request.finding84 = finding84.value;
        request.evidence85 = evidence85.value;
        request.finding85 = finding85.value;
        request.evidence86 = evidence86.value;
        request.finding86 = finding86.value;
        request.evidence87 = evidence87.value;
        request.finding87 = finding87.value;
        request.evidence88 = evidence88.value;
        request.finding88 = finding88.value;
        request.evidence89 = evidence89.value;
        request.finding89 = finding89.value;
        request.evidence90 = evidence90.value;
        request.finding90 = finding90.value;
        request.evidence91 = evidence91.value;
        request.finding91 = finding91.value;
        request.evidence92 = evidence92.value;
        request.finding92 = finding92.value;
        request.evidence93 = evidence93.value;
        request.finding93 = finding93.value;
        request.evidence94 = evidence94.value;
        request.finding94 = finding94.value;
        request.evidence95 = evidence95.value;
        request.finding95 = finding95.value;
        request.evidence96 = evidence96.value;
        request.finding96 = finding96.value;
        request.evidence97 = evidence97.value;
        request.finding97 = finding97.value;
        request.evidence98 = evidence98.value;
        request.finding98 = finding98.value;
        request.evidence99 = evidence99.value;
        request.finding99 = finding99.value;
        request.evidence100 = evidence100.value;
        request.finding100 = finding100.value;
        request.evidence101 = evidence101.value;
        request.finding101 = finding101.value;
        request.evidence102 = evidence102.value;
        request.finding102 = finding102.value;
        request.evidence103 = evidence103.value;
        request.finding103 = finding103.value;
        request.evidence104 = evidence104.value;
        request.finding104 = finding104.value;
        request.evidence105 = evidence105.value;
        request.finding105 = finding105.value;
        request.evidence106 = evidence106.value;
        request.finding106 = finding106.value;
        request.evidence107 = evidence107.value;
        request.finding107 = finding107.value;
        request.evidence108 = evidence108.value;
        request.finding108 = finding108.value;
        request.evidence109 = evidence109.value;
        request.finding109 = finding109.value;
        request.evidence110 = evidence110.value;
        request.finding110 = finding110.value;
        request.evidence111 = evidence111.value;
        request.finding111 = finding111.value;
        request.evidence112 = evidence112.value;
        request.finding112 = finding112.value;
        request.evidence113 = evidence113.value;
        request.finding113 = finding113.value;
        request.evidence114 = evidence114.value;
        request.finding114 = finding114.value;
        request.evidence115 = evidence115.value;
        request.finding115 = finding115.value;
        request.evidence116 = evidence116.value;
        request.finding116 = finding116.value;
        request.evidence117 = evidence117.value;
        request.finding117 = finding117.value;
        request.evidence118 = evidence118.value;
        request.finding118 = finding118.value;
        request.evidence125 = evidence125.value;
        request.finding125 = finding125.value;
        request.evidence126 = evidence126.value;
        request.finding126 = finding126.value;
        request.evidence128 = evidence128.value;
        request.finding128 = finding128.value;
        request.evidence129 = evidence129.value;
        request.finding129 = finding129.value;
        request.evidence130 = evidence130.value;
        request.finding130 = finding130.value;
        request.evidence131 = evidence131.value;
        request.finding131 = finding131.value;
        request.evidence132 = evidence132.value;
        request.finding132 = finding132.value;
        request.evidence133 = evidence133.value;
        request.finding133 = finding133.value;
        request.evidence134 = evidence134.value;
        request.finding134 = finding134.value;
        request.evidence135 = evidence135.value;
        request.finding135 = finding135.value;
        request.evidence136 = evidence136.value;
        request.finding136 = finding136.value;
        request.evidence137 = evidence137.value;
        request.finding137 = finding137.value;
        request.evidence138 = evidence138.value;
        request.finding138 = finding138.value;
        request.scope = scope.value;
        request.date1 = moment(date1.value, "DD/MM/YYYY");
        request.date2 = moment(date2.value, "DD/MM/YYYY");
        request.date3 = moment(date3.value, "DD/MM/YYYY");
        request.date4 = moment(date4.value, "DD/MM/YYYY");
        request.auditor = auditor.value;
        request.auditee = auditee.value;
        request.location = location.value;
        request.approvedYear = this.state.selectedYear;
        return request;
    }

    handleAddRow() {
        let record = undefined;
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            id: record ? record.id : null,
            scope: record ? record.scope : "",
            location: record ? record.location : "",
            auditor: record ? record.auditor : "",
            date1: record ? record.date1 : "",
            date2: record ? record.date2 : "",
            date3: record ? record.date3 : "",
            date4: record ? record.date4 : "",
            auditee: record ? record.auditee : "",
            displayDate: record ? record.displayDate : "",
            evidence1: record ? record.evidence1 : "",
            finding1: record ? record.finding1 : "",
            evidence2: record ? record.evidence2 : "",
            finding2: record ? record.finding2 : "",
            evidence3: record ? record.evidence3 : "",
            finding3: record ? record.finding3 : "",
            evidence4: record ? record.evidence4 : "",
            finding4: record ? record.finding4 : "",
            evidence5: record ? record.evidence5 : "",
            finding5: record ? record.finding5 : "",
            evidence6: record ? record.evidence6 : "",
            finding6: record ? record.finding6 : "",
            evidence7: record ? record.evidence7 : "",
            finding7: record ? record.finding7 : "",
            evidence8: record ? record.evidence8 : "",
            finding8: record ? record.finding8 : "",
            evidence9: record ? record.evidence9 : "",
            finding9: record ? record.finding9 : "",
            evidence10: record ? record.evidence10 : "",
            finding10: record ? record.finding10 : "",
            evidence11: record ? record.evidence11 : "",
            finding11: record ? record.finding11 : "",
            evidence12: record ? record.evidence12 : "",
            finding12: record ? record.finding12 : "",
            evidence13: record ? record.evidence13 : "",
            finding13: record ? record.finding13 : "",
            evidence14: record ? record.evidence14 : "",
            finding14: record ? record.finding14 : "",
            evidence15: record ? record.evidence15 : "",
            finding15: record ? record.finding15 : "",
            evidence16: record ? record.evidence16 : "",
            finding16: record ? record.finding16 : "",
            evidence17: record ? record.evidence17 : "",
            finding17: record ? record.finding17 : "",
            evidence18: record ? record.evidence18 : "",
            finding18: record ? record.finding18 : "",
            evidence19: record ? record.evidence19 : "",
            finding19: record ? record.finding19 : "",
            evidence20: record ? record.evidence20 : "",
            finding20: record ? record.finding20 : "",
            evidence21: record ? record.evidence21 : "",
            finding21: record ? record.finding21 : "",
            evidence22: record ? record.evidence22 : "",
            finding22: record ? record.finding22 : "",
            evidence23: record ? record.evidence23 : "",
            finding23: record ? record.finding23 : "",
            evidence24: record ? record.evidence24 : "",
            finding24: record ? record.finding24 : "",
            evidence25: record ? record.evidence25 : "",
            finding25: record ? record.finding25 : "",
            evidence26: record ? record.evidence26 : "",
            finding26: record ? record.finding26 : "",
            evidence27: record ? record.evidence27 : "",
            finding27: record ? record.finding27 : "",
            evidence28: record ? record.evidence28 : "",
            finding28: record ? record.finding28 : "",
            evidence29: record ? record.evidence29 : "",
            finding29: record ? record.finding29 : "",
            evidence30: record ? record.evidence30 : "",
            finding30: record ? record.finding30 : "",
            evidence31: record ? record.evidence31 : "",
            finding31: record ? record.finding31 : "",
            evidence32: record ? record.evidence32 : "",
            finding32: record ? record.finding32 : "",
            evidence33: record ? record.evidence33 : "",
            finding33: record ? record.finding33 : "",
            evidence34: record ? record.evidence34 : "",
            finding34: record ? record.finding34 : "",
            evidence35: record ? record.evidence35 : "",
            finding35: record ? record.finding35 : "",
            evidence36: record ? record.evidence36 : "",
            finding36: record ? record.finding36 : "",
            evidence37: record ? record.evidence37 : "",
            finding37: record ? record.finding37 : "",
            evidence38: record ? record.evidence38 : "",
            finding38: record ? record.finding38 : "",
            evidence39: record ? record.evidence39 : "",
            finding39: record ? record.finding39 : "",
            evidence40: record ? record.evidence40 : "",
            finding40: record ? record.finding40 : "",
            evidence41: record ? record.evidence41 : "",
            finding41: record ? record.finding41 : "",
            evidence42: record ? record.evidence42 : "",
            finding42: record ? record.finding42 : "",
            evidence43: record ? record.evidence43 : "",
            finding43: record ? record.finding43 : "",
            evidence44: record ? record.evidence44 : "",
            finding44: record ? record.finding44 : "",
            evidence45: record ? record.evidence45 : "",
            finding45: record ? record.finding45 : "",
            evidence46: record ? record.evidence46 : "",
            finding46: record ? record.finding46 : "",
            evidence47: record ? record.evidence47 : "",
            finding47: record ? record.finding47 : "",
            evidence48: record ? record.evidence48 : "",
            finding48: record ? record.finding48 : "",
            evidence49: record ? record.evidence49 : "",
            finding49: record ? record.finding49 : "",
            evidence50: record ? record.evidence50 : "",
            finding50: record ? record.finding50 : "",
            evidence51: record ? record.evidence51 : "",
            finding51: record ? record.finding51 : "",
            evidence52: record ? record.evidence52 : "",
            finding52: record ? record.finding52 : "",
            evidence53: record ? record.evidence53 : "",
            finding53: record ? record.finding53 : "",
            evidence54: record ? record.evidence54 : "",
            finding54: record ? record.finding54 : "",
            evidence55: record ? record.evidence55 : "",
            finding55: record ? record.finding55 : "",
            evidence56: record ? record.evidence56 : "",
            finding56: record ? record.finding56 : "",
            evidence57: record ? record.evidence57 : "",
            finding57: record ? record.finding57 : "",
            evidence59: record ? record.evidence59 : "",
            finding59: record ? record.finding59 : "",
            evidence60: record ? record.evidence60 : "",
            finding60: record ? record.finding60 : "",
            evidence64: record ? record.evidence64 : "",
            finding64: record ? record.finding64 : "",
            evidence65: record ? record.evidence65 : "",
            finding65: record ? record.finding65 : "",
            evidence66: record ? record.evidence66 : "",
            finding66: record ? record.finding66 : "",
            evidence67: record ? record.evidence67 : "",
            finding67: record ? record.finding67 : "",
            evidence68: record ? record.evidence68 : "",
            finding68: record ? record.finding68 : "",
            evidence69: record ? record.evidence69 : "",
            finding69: record ? record.finding69 : "",
            evidence70: record ? record.evidence70 : "",
            finding70: record ? record.finding70 : "",
            evidence71: record ? record.evidence71 : "",
            finding71: record ? record.finding71 : "",
            evidence72: record ? record.evidence72 : "",
            finding72: record ? record.finding72 : "",
            evidence73: record ? record.evidence73 : "",
            finding73: record ? record.finding73 : "",
            evidence74: record ? record.evidence74 : "",
            finding74: record ? record.finding74 : "",
            evidence75: record ? record.evidence75 : "",
            finding75: record ? record.finding75 : "",
            evidence76: record ? record.evidence76 : "",
            finding76: record ? record.finding76 : "",
            evidence77: record ? record.evidence77 : "",
            finding77: record ? record.finding77 : "",
            evidence78: record ? record.evidence78 : "",
            finding78: record ? record.finding78 : "",
            evidence79: record ? record.evidence79 : "",
            finding79: record ? record.finding79 : "",
            evidence80: record ? record.evidence80 : "",
            finding80: record ? record.finding80 : "",
            evidence81: record ? record.evidence81 : "",
            finding81: record ? record.finding81 : "",
            evidence82: record ? record.evidence82 : "",
            finding82: record ? record.finding82 : "",
            evidence83: record ? record.evidence83 : "",
            finding83: record ? record.finding83 : "",
            evidence84: record ? record.evidence84 : "",
            finding84: record ? record.finding84 : "",
            evidence85: record ? record.evidence85 : "",
            finding85: record ? record.finding85 : "",
            evidence86: record ? record.evidence86 : "",
            finding86: record ? record.finding86 : "",
            evidence87: record ? record.evidence87 : "",
            finding87: record ? record.finding87 : "",
            evidence88: record ? record.evidence88 : "",
            finding88: record ? record.finding88 : "",
            evidence89: record ? record.evidence89 : "",
            finding89: record ? record.finding89 : "",
            evidence90: record ? record.evidence90 : "",
            finding90: record ? record.finding90 : "",
            evidence91: record ? record.evidence91 : "",
            finding91: record ? record.finding91 : "",
            evidence92: record ? record.evidence92 : "",
            finding92: record ? record.finding92 : "",
            evidence93: record ? record.evidence93 : "",
            finding93: record ? record.finding93 : "",
            evidence94: record ? record.evidence94 : "",
            finding94: record ? record.finding94 : "",
            evidence95: record ? record.evidence95 : "",
            finding95: record ? record.finding95 : "",
            evidence96: record ? record.evidence96 : "",
            finding96: record ? record.finding96 : "",
            evidence97: record ? record.evidence97 : "",
            finding97: record ? record.finding97 : "",
            evidence98: record ? record.evidence98 : "",
            finding98: record ? record.finding98 : "",
            evidence99: record ? record.evidence99 : "",
            finding99: record ? record.finding99 : "",
            evidence100: record ? record.evidence100 : "",
            finding100: record ? record.finding100 : "",
            evidence101: record ? record.evidence101 : "",
            finding101: record ? record.finding101 : "",
            evidence102: record ? record.evidence102 : "",
            finding102: record ? record.finding102 : "",
            evidence103: record ? record.evidence103 : "",
            finding103: record ? record.finding103 : "",
            evidence104: record ? record.evidence104 : "",
            finding104: record ? record.finding104 : "",
            evidence105: record ? record.evidence105 : "",
            finding105: record ? record.finding105 : "",
            evidence106: record ? record.evidence106 : "",
            finding106: record ? record.finding106 : "",
            evidence107: record ? record.evidence107 : "",
            finding107: record ? record.finding107 : "",
            evidence108: record ? record.evidence108 : "",
            finding108: record ? record.finding108 : "",
            evidence109: record ? record.evidence109 : "",
            finding109: record ? record.finding109 : "",
            evidence110: record ? record.evidence110 : "",
            finding110: record ? record.finding110 : "",
            evidence111: record ? record.evidence111 : "",
            finding111: record ? record.finding111 : "",
            evidence112: record ? record.evidence112 : "",
            finding112: record ? record.finding112 : "",
            evidence113: record ? record.evidence113 : "",
            finding113: record ? record.finding113 : "",
            evidence114: record ? record.evidence114 : "",
            finding114: record ? record.finding114 : "",
            evidence115: record ? record.evidence115 : "",
            finding115: record ? record.finding115 : "",
            evidence116: record ? record.evidence116 : "",
            finding116: record ? record.finding116 : "",
            evidence117: record ? record.evidence117 : "",
            finding117: record ? record.finding117 : "",
            evidence118: record ? record.evidence118 : "",
            finding118: record ? record.finding118 : "",
            evidence125: record ? record.evidence125 : "",
            finding125: record ? record.finding125 : "",
            evidence126: record ? record.evidence126 : "",
            finding126: record ? record.finding126 : "",
            evidence128: record ? record.evidence128 : "",
            finding128: record ? record.finding128 : "",
            evidence129: record ? record.evidence129 : "",
            finding129: record ? record.finding129 : "",
            evidence130: record ? record.evidence130 : "",
            finding130: record ? record.finding130 : "",
            evidence131: record ? record.evidence131 : "",
            finding131: record ? record.finding131 : "",
            evidence132: record ? record.evidence132 : "",
            finding132: record ? record.finding132 : "",
            evidence133: record ? record.evidence133 : "",
            finding133: record ? record.finding133 : "",
            evidence134: record ? record.evidence134 : "",
            finding134: record ? record.finding134 : "",
            evidence135: record ? record.evidence135 : "",
            finding135: record ? record.finding135 : "",
            evidence136: record ? record.evidence136 : "",
            finding136: record ? record.finding136 : "",
            evidence137: record ? record.evidence137 : "",
            finding137: record ? record.finding137 : "",
            evidence138: record ? record.evidence138 : "",
            finding138: record ? record.finding138 : "",
        })
    }

    saveImsAuditChecklist() {
        let request = this.captureFromFrontEnd();
        console.log('request', request);
        saveOrUpdateImsAuditChecklist(request)
            .then(() => {
                this.loadImsAuditChecklist(this.state.selectedYear);
                NotificationManager.success('Success', 'The IMS Audit Checklist has been updated.', 5000);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    isValid(newData) {
        let isValid = newData.name && newData.name !== '';
        if (!isValid) {
            NotificationManager.error('Error', 'Validation Error. Supplier Name is required', 5000);
        }
        return isValid;
    }

    onDelete(record) {
        console.log(record);
        deleteDocumentRetention(record)
            .then(() => {
                NotificationManager.success('Success', 'The Record has been removed.', 5000);
            }).catch(error => {
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onEdit(record) {
        window.scrollTo(0, 0);
        this.setState({
            isEditing: true,
            imsChecklist: record,
            id: record ? record.id : null,
            scope: record ? record.scope : "",
            location: record ? record.location : "",
            auditor: record ? record.auditor : "",
            date1: record ? record.date1 : "",
            date2: record ? record.date2 : "",
            date3: record ? record.date3 : "",
            date4: record ? record.date4 : "",
            auditee: record ? record.auditee : "",
            displayDate: record ? record.displayDate : "",
            evidence1: record ? record.evidence1 : "",
            finding1: record ? record.finding1 : "",
            evidence2: record ? record.evidence2 : "",
            finding2: record ? record.finding2 : "",
            evidence3: record ? record.evidence3 : "",
            finding3: record ? record.finding3 : "",
            evidence4: record ? record.evidence4 : "",
            finding4: record ? record.finding4 : "",
            evidence5: record ? record.evidence5 : "",
            finding5: record ? record.finding5 : "",
            evidence6: record ? record.evidence6 : "",
            finding6: record ? record.finding6 : "",
            evidence7: record ? record.evidence7 : "",
            finding7: record ? record.finding7 : "",
            evidence8: record ? record.evidence8 : "",
            finding8: record ? record.finding8 : "",
            evidence9: record ? record.evidence9 : "",
            finding9: record ? record.finding9 : "",
            evidence10: record ? record.evidence10 : "",
            finding10: record ? record.finding10 : "",
            evidence11: record ? record.evidence11 : "",
            finding11: record ? record.finding11 : "",
            evidence12: record ? record.evidence12 : "",
            finding12: record ? record.finding12 : "",
            evidence13: record ? record.evidence13 : "",
            finding13: record ? record.finding13 : "",
            evidence14: record ? record.evidence14 : "",
            finding14: record ? record.finding14 : "",
            evidence15: record ? record.evidence15 : "",
            finding15: record ? record.finding15 : "",
            evidence16: record ? record.evidence16 : "",
            finding16: record ? record.finding16 : "",
            evidence17: record ? record.evidence17 : "",
            finding17: record ? record.finding17 : "",
            evidence18: record ? record.evidence18 : "",
            finding18: record ? record.finding18 : "",
            evidence19: record ? record.evidence19 : "",
            finding19: record ? record.finding19 : "",
            evidence20: record ? record.evidence20 : "",
            finding20: record ? record.finding20 : "",
            evidence21: record ? record.evidence21 : "",
            finding21: record ? record.finding21 : "",
            evidence22: record ? record.evidence22 : "",
            finding22: record ? record.finding22 : "",
            evidence23: record ? record.evidence23 : "",
            finding23: record ? record.finding23 : "",
            evidence24: record ? record.evidence24 : "",
            finding24: record ? record.finding24 : "",
            evidence25: record ? record.evidence25 : "",
            finding25: record ? record.finding25 : "",
            evidence26: record ? record.evidence26 : "",
            finding26: record ? record.finding26 : "",
            evidence27: record ? record.evidence27 : "",
            finding27: record ? record.finding27 : "",
            evidence28: record ? record.evidence28 : "",
            finding28: record ? record.finding28 : "",
            evidence29: record ? record.evidence29 : "",
            finding29: record ? record.finding29 : "",
            evidence30: record ? record.evidence30 : "",
            finding30: record ? record.finding30 : "",
            evidence31: record ? record.evidence31 : "",
            finding31: record ? record.finding31 : "",
            evidence32: record ? record.evidence32 : "",
            finding32: record ? record.finding32 : "",
            evidence33: record ? record.evidence33 : "",
            finding33: record ? record.finding33 : "",
            evidence34: record ? record.evidence34 : "",
            finding34: record ? record.finding34 : "",
            evidence35: record ? record.evidence35 : "",
            finding35: record ? record.finding35 : "",
            evidence36: record ? record.evidence36 : "",
            finding36: record ? record.finding36 : "",
            evidence37: record ? record.evidence37 : "",
            finding37: record ? record.finding37 : "",
            evidence38: record ? record.evidence38 : "",
            finding38: record ? record.finding38 : "",
            evidence39: record ? record.evidence39 : "",
            finding39: record ? record.finding39 : "",
            evidence40: record ? record.evidence40 : "",
            finding40: record ? record.finding40 : "",
            evidence41: record ? record.evidence41 : "",
            finding41: record ? record.finding41 : "",
            evidence42: record ? record.evidence42 : "",
            finding42: record ? record.finding42 : "",
            evidence43: record ? record.evidence43 : "",
            finding43: record ? record.finding43 : "",
            evidence44: record ? record.evidence44 : "",
            finding44: record ? record.finding44 : "",
            evidence45: record ? record.evidence45 : "",
            finding45: record ? record.finding45 : "",
            evidence46: record ? record.evidence46 : "",
            finding46: record ? record.finding46 : "",
            evidence47: record ? record.evidence47 : "",
            finding47: record ? record.finding47 : "",
            evidence48: record ? record.evidence48 : "",
            finding48: record ? record.finding48 : "",
            evidence49: record ? record.evidence49 : "",
            finding49: record ? record.finding49 : "",
            evidence50: record ? record.evidence50 : "",
            finding50: record ? record.finding50 : "",
            evidence51: record ? record.evidence51 : "",
            finding51: record ? record.finding51 : "",
            evidence52: record ? record.evidence52 : "",
            finding52: record ? record.finding52 : "",
            evidence53: record ? record.evidence53 : "",
            finding53: record ? record.finding53 : "",
            evidence54: record ? record.evidence54 : "",
            finding54: record ? record.finding54 : "",
            evidence55: record ? record.evidence55 : "",
            finding55: record ? record.finding55 : "",
            evidence56: record ? record.evidence56 : "",
            finding56: record ? record.finding56 : "",
            evidence57: record ? record.evidence57 : "",
            finding57: record ? record.finding57 : "",
            evidence59: record ? record.evidence59 : "",
            finding59: record ? record.finding59 : "",
            evidence60: record ? record.evidence60 : "",
            finding60: record ? record.finding60 : "",
            evidence64: record ? record.evidence64 : "",
            finding64: record ? record.finding64 : "",
            evidence65: record ? record.evidence65 : "",
            finding65: record ? record.finding65 : "",
            evidence66: record ? record.evidence66 : "",
            finding66: record ? record.finding66 : "",
            evidence67: record ? record.evidence67 : "",
            finding67: record ? record.finding67 : "",
            evidence68: record ? record.evidence68 : "",
            finding68: record ? record.finding68 : "",
            evidence69: record ? record.evidence69 : "",
            finding69: record ? record.finding69 : "",
            evidence70: record ? record.evidence70 : "",
            finding70: record ? record.finding70 : "",
            evidence71: record ? record.evidence71 : "",
            finding71: record ? record.finding71 : "",
            evidence72: record ? record.evidence72 : "",
            finding72: record ? record.finding72 : "",
            evidence73: record ? record.evidence73 : "",
            finding73: record ? record.finding73 : "",
            evidence74: record ? record.evidence74 : "",
            finding74: record ? record.finding74 : "",
            evidence75: record ? record.evidence75 : "",
            finding75: record ? record.finding75 : "",
            evidence76: record ? record.evidence76 : "",
            finding76: record ? record.finding76 : "",
            evidence77: record ? record.evidence77 : "",
            finding77: record ? record.finding77 : "",
            evidence78: record ? record.evidence78 : "",
            finding78: record ? record.finding78 : "",
            evidence79: record ? record.evidence79 : "",
            finding79: record ? record.finding79 : "",
            evidence80: record ? record.evidence80 : "",
            finding80: record ? record.finding80 : "",
            evidence81: record ? record.evidence81 : "",
            finding81: record ? record.finding81 : "",
            evidence82: record ? record.evidence82 : "",
            finding82: record ? record.finding82 : "",
            evidence83: record ? record.evidence83 : "",
            finding83: record ? record.finding83 : "",
            evidence84: record ? record.evidence84 : "",
            finding84: record ? record.finding84 : "",
            evidence85: record ? record.evidence85 : "",
            finding85: record ? record.finding85 : "",
            evidence86: record ? record.evidence86 : "",
            finding86: record ? record.finding86 : "",
            evidence87: record ? record.evidence87 : "",
            finding87: record ? record.finding87 : "",
            evidence88: record ? record.evidence88 : "",
            finding88: record ? record.finding88 : "",
            evidence89: record ? record.evidence89 : "",
            finding89: record ? record.finding89 : "",
            evidence90: record ? record.evidence90 : "",
            finding90: record ? record.finding90 : "",
            evidence91: record ? record.evidence91 : "",
            finding91: record ? record.finding91 : "",
            evidence92: record ? record.evidence92 : "",
            finding92: record ? record.finding92 : "",
            evidence93: record ? record.evidence93 : "",
            finding93: record ? record.finding93 : "",
            evidence94: record ? record.evidence94 : "",
            finding94: record ? record.finding94 : "",
            evidence95: record ? record.evidence95 : "",
            finding95: record ? record.finding95 : "",
            evidence96: record ? record.evidence96 : "",
            finding96: record ? record.finding96 : "",
            evidence97: record ? record.evidence97 : "",
            finding97: record ? record.finding97 : "",
            evidence98: record ? record.evidence98 : "",
            finding98: record ? record.finding98 : "",
            evidence99: record ? record.evidence99 : "",
            finding99: record ? record.finding99 : "",
            evidence100: record ? record.evidence100 : "",
            finding100: record ? record.finding100 : "",
            evidence101: record ? record.evidence101 : "",
            finding101: record ? record.finding101 : "",
            evidence102: record ? record.evidence102 : "",
            finding102: record ? record.finding102 : "",
            evidence103: record ? record.evidence103 : "",
            finding103: record ? record.finding103 : "",
            evidence104: record ? record.evidence104 : "",
            finding104: record ? record.finding104 : "",
            evidence105: record ? record.evidence105 : "",
            finding105: record ? record.finding105 : "",
            evidence106: record ? record.evidence106 : "",
            finding106: record ? record.finding106 : "",
            evidence107: record ? record.evidence107 : "",
            finding107: record ? record.finding107 : "",
            evidence108: record ? record.evidence108 : "",
            finding108: record ? record.finding108 : "",
            evidence109: record ? record.evidence109 : "",
            finding109: record ? record.finding109 : "",
            evidence110: record ? record.evidence110 : "",
            finding110: record ? record.finding110 : "",
            evidence111: record ? record.evidence111 : "",
            finding111: record ? record.finding111 : "",
            evidence112: record ? record.evidence112 : "",
            finding112: record ? record.finding112 : "",
            evidence113: record ? record.evidence113 : "",
            finding113: record ? record.finding113 : "",
            evidence114: record ? record.evidence114 : "",
            finding114: record ? record.finding114 : "",
            evidence115: record ? record.evidence115 : "",
            finding115: record ? record.finding115 : "",
            evidence116: record ? record.evidence116 : "",
            finding116: record ? record.finding116 : "",
            evidence117: record ? record.evidence117 : "",
            finding117: record ? record.finding117 : "",
            evidence118: record ? record.evidence118 : "",
            finding118: record ? record.finding118 : "",
            evidence125: record ? record.evidence125 : "",
            finding125: record ? record.finding125 : "",
            evidence126: record ? record.evidence126 : "",
            finding126: record ? record.finding126 : "",
            evidence128: record ? record.evidence128 : "",
            finding128: record ? record.finding128 : "",
            evidence129: record ? record.evidence129 : "",
            finding129: record ? record.finding129 : "",
            evidence130: record ? record.evidence130 : "",
            finding130: record ? record.finding130 : "",
            evidence131: record ? record.evidence131 : "",
            finding131: record ? record.finding131 : "",
            evidence132: record ? record.evidence132 : "",
            finding132: record ? record.finding132 : "",
            evidence133: record ? record.evidence133 : "",
            finding133: record ? record.finding133 : "",
            evidence134: record ? record.evidence134 : "",
            finding134: record ? record.finding134 : "",
            evidence135: record ? record.evidence135 : "",
            finding135: record ? record.finding135 : "",
            evidence136: record ? record.evidence136 : "",
            finding136: record ? record.finding136 : "",
            evidence137: record ? record.evidence137 : "",
            finding137: record ? record.finding137 : "",
            evidence138: record ? record.evidence138 : "",
            finding138: record ? record.finding138 : "",
        });
    }

    exportSingleReport(selectedId) {
        let request = new XMLHttpRequest();
        request.open('GET', V1_API_URL_PREFIX + "/ims-audit-checklist/export?selectedYear=" + this.state.selectedYear + "&selectedId=" + (selectedId ? (selectedId) : ""), true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        if (localStorage.getItem(ACCESS_TOKEN)) {
            request.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
        }

        if (localStorage.getItem(BOUND_USER_ID)) {
            request.setRequestHeader(BOUND_USER_ID, localStorage.getItem(BOUND_USER_ID));
        }
        request.responseType = 'blob';

        request.onload = function() {
            // Only handle status code 200
            if(request.status === 200) {
                const disposition = request.getResponseHeader('Content-Disposition');
                const filename =  disposition.split('filename=')[1];
                const contentType = request.getResponseHeader('Content-Type');


                // The actual download
                let blob = new Blob([request.response], { type: contentType });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;

                document.body.appendChild(link);

                link.click();
                document.body.removeChild(link);
            }
            // some error handling should be done here...
        };

        request.send(null);
    }

    exportReport() {
        this.exportSingleReport(undefined);
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        console.log('finding1', state.finding1);
        console.log('evidence1', state.evidence1);
        let { imsAuditChecklist } = state;
        const { show, latestRevision } = this.state;
        const isRevision = latestRevision.date && latestRevision.author && latestRevision.approvedBy;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        return <div>
            <form ref={form => this.form = form}>
                    <Paper className={classes.root}>
                        {!this.state.isEditing && <React.Fragment>
                            <Typography component="h2" variant="h5">
                                <div style={{float: 'left'}}>IMS AUDIT CHECKLIST</div>
                            </Typography><br/>
                        <ExpansionPanel defaultExpanded style={{ paddingBottom: '15px'}}>
                            <Card className={classes.card} style={{ paddingTop: '30px'}}>
                                <CardHeader
                                    action={!isAuditor &&
                                        <BlueButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleOutlineTwoTone/>}
                                            onClick={this.showModal}
                                            size="small"
                                            style={{marginRight: '10px'}}
                                        >
                                            ADD REVISION
                                        </BlueButton>
                                    }
                                    title={
                                        <span style={{color: "darkblue"}}>
                                            <p><b>{latestRevision.title}</b></p>
                                            <p>{isRevision && `Revision ${latestRevision.number} Author: ${latestRevision.author}`}</p>
                                                    </span>
                                                }
                                                subheader={
                                                    isRevision &&
                                                    <span>
                                        <p>Approved for suitability and adequacy by: {latestRevision.approvedBy} on {moment(latestRevision.date).format('DD/MM/YYYY')}</p>
                                    </span>
                                    }
                                />
                        </Card>
                                    <hr/>
                            <ExpansionPanelDetails>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        style={{float: 'left', paddingTop: '30px'}}
                                        disableToolbar
                                        autoOk
                                        variant="inline"
                                        format="YYYY"
                                        margin="normal"
                                        id="selectedYear"
                                        label="Filter by Year"
                                        name="selectedYear"
                                        value={state.selectedYear}
                                        views={['year']}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        onChange={ this.onYearSelected}
                                    />
                                </MuiPickersUtilsProvider>
                            </ExpansionPanelDetails>
                            <hr/>
                            <ExpansionPanelDetails>
                                <Typography style={{ width: "100%" }}>
                                    {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => this.exportReport()} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                                    <TableComponent
                                    tableKey="imsChecklistAuditTable"
                                    data={state.imsAuditChecklist}
                                    columns={columns}
                                    handleSubmit={this.handleSubmit}
                                    handleAddRow={this.handleAddRow}
                                    handleRowDel={this.onDelete}
                                    handleRowEdit={this.onEdit}
                                    pagination={true}
                                    allowAdd={isRevision && !isAuditor ? 'show' : 'disable'}
                                    allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                                />
                                </Typography>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                            </React.Fragment>}
                            {this.state.isEditing && <React.Fragment>
                                <Typography component="h2" variant="h5" style={{ paddingBottom: '30px'}}>
                                    <div style={{float: 'left'}}>EDITING IMS AUDIT CHECKLIST</div>
                                </Typography>
                                <br/>
                            <ExpansionPanelDetails>
                                <Typography style={{ width: "100%" }}>
                                    <ImsAuditChecklistHeader
                                        state={state}
                                    />
                                </Typography>
                            </ExpansionPanelDetails>
                        <ExpansionPanel defaultExpanded style={{ paddingTop: '15px'}}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreTwoTone />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                                style={{ backgroundColor: 'lightyellow', color: 'black'}}
                            >
                                <Typography component="h3" variant="h5">
                                    CONTEXT OF THE ORGANISATION
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{ padding: '0px' }}>
                                <Grid container spacing={0}>
                                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                                        <Paper className={classes.paper} square>
                                            <TableContainer component={Paper}>
                                                <Table className={classes.table} aria-label="spanning table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" rowspan={3} style={{ backgroundColor: 'yellow', width: "5%"}}>Item No.</TableCell>
                                                            <TableCell align="center" colSpan={3} style={{ backgroundColor: 'lightgreen', width: "10%"}}>
                                                                Standard Clause
                                                            </TableCell>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen', width: "15%"}} rowspan={2}>COMPLIANCE REQUIREMENTS</TableCell>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen', width: "35%"}} rowspan={2}>EVIDENCE VIEWED DURING THE AUDIT</TableCell>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen', width: "35%"}} rowspan={2}>AUDIT FINDING</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen'}}>ISO 9001-2015</TableCell>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen'}}>ISO 14001-2015</TableCell>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen'}}>ISO 45001:2018</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center" colSpan={3} style={{ backgroundColor: 'lightgreen'}}/>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen'}}/>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen'}}/>
                                                            <TableCell align="center" style={{ backgroundColor: 'lightgreen'}}>Conformance (C)/Nonconformance (NC)/Observation (OBS)</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"1"}
                                                            header={"CONTEXT OF THE ORGANISATION"}
                                                            iso9001={"4.1\n4.2\n6.1.1\n6.1.2"}
                                                            iso14001={"4.1\n4.2\n5.1\n6.1.1"}
                                                            iso45001={"4.1\n4.2\n5.1\n6.1.1\n6.1.4\n6.1.2.2\n6.1.2.3"}
                                                            qualityRequirement={"Are Risk and Opportunities identified and form part of the Risk Register?"}
                                                            auditFinding={state.finding1}
                                                            auditFindingName={"finding1"}
                                                            evidenceViewed={state.evidence1}
                                                            evidenceViewedName={"evidence1"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"2"}
                                                            iso9001={"6.1.2"}
                                                            iso14001={"6.1.1"}
                                                            iso45001={"6.1.4"}
                                                            qualityRequirement={"Has the organisation implemented a risk assessment?"}
                                                            auditFinding={state.finding2}
                                                            auditFindingName={"finding2"}
                                                            evidenceViewed={state.evidence2}
                                                            evidenceViewedName={"evidence2"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"3"}
                                                            iso9001={"4.4.1\n6.1.2"}
                                                            iso14001={"6.1.1\n6.1.4"}
                                                            iso45001={"6.1.1\n6.1.2.2\n6.1.2.3"}
                                                            qualityRequirement={"Are actions to address  risks and opportunities appropriate?"}
                                                            auditFinding={state.finding3}
                                                            auditFindingName={"finding3"}
                                                            evidenceViewed={state.evidence3}
                                                            evidenceViewedName={"evidence3"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"4"}
                                                            iso9001={"4.2\n5.1.2"}
                                                            iso14001={"4.2\n5.1"}
                                                            iso45001={"4.2\n5.1"}
                                                            qualityRequirement={"Are relevant interested parties identified? Their requirements, statutory and regulatory requirements, issues related to product conformity and customer satisfaction?"}
                                                            auditFinding={state.finding4}
                                                            auditFindingName={"finding4"}
                                                            evidenceViewed={state.evidence4}
                                                            evidenceViewedName={"evidence4"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"5"}
                                                            iso9001={"4.3"}
                                                            iso14001={"4.3"}
                                                            iso45001={"4.3"}
                                                            qualityRequirement={"Is the scope of the IMS and boundaries of the IMS documented?\n" +
                                                            "NOTE:  Do the boundaries outline what the IMS covers and what aspects of the business are not covered?"}
                                                            auditFinding={state.finding5}
                                                            auditFindingName={"finding5"}
                                                            evidenceViewed={state.evidence5}
                                                            evidenceViewedName={"evidence5"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"6"}
                                                            iso9001={"4.3"}
                                                            iso14001={"4.3"}
                                                            iso45001={"4.3"}
                                                            qualityRequirement={"Does the Scope of the IMS consider the requirements of interested parties, organisation, products and services, compliance obligations?\nHave interested parties been defined by the organisation?"}
                                                            auditFinding={state.finding6}
                                                            auditFindingName={"finding6"}
                                                            evidenceViewed={state.evidence6}
                                                            evidenceViewedName={"evidence6"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"7"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Legally identifiable (ABN)?   Does the ABN outlined on documentation correlate with the ABN nominated on the ASIC register?\nHas a cross check been conducted against the ASIC website ABN lookup.com. ?"}
                                                            auditFinding={state.finding7}
                                                            auditFindingName={"finding7"}
                                                            evidenceViewed={state.evidence7}
                                                            evidenceViewedName={"evidence7"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"8"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have work activities conducted impartially?\nPolicy has been developed and implemented?\nHave any risks to impartiality been identified on an on-going basis?"}
                                                            auditFinding={state.finding8}
                                                            auditFindingName={"finding8"}
                                                            evidenceViewed={state.evidence8}
                                                            evidenceViewedName={"evidence8"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"9"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are provisions in place to maintain confidentiality, (legally enforceable)?"}
                                                            auditFinding={state.finding9}
                                                            auditFindingName={"finding9"}
                                                            evidenceViewed={state.evidence9}
                                                            evidenceViewedName={"evidence9"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"10"}
                                                            iso9001={"4.4.1"}
                                                            iso14001={"4.4\n8.1"}
                                                            iso45001={"4.4\n8.1.1"}
                                                            qualityRequirement={"Is there confidentiality provisions in employment contracts?  If yes, have the contracts been executed and filed in accordance with documented processes?"}
                                                            auditFinding={state.finding10}
                                                            auditFindingName={"finding10"}
                                                            evidenceViewed={state.evidence10}
                                                            evidenceViewedName={"evidence10"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"11"}
                                                            iso9001={"4.4.1\n5.1.1\n5.3"}
                                                            iso14001={"5.1\n5.3"}
                                                            iso45001={"5.3"}
                                                            qualityRequirement={"Are responsibilities and authorities for these processes identified and assigned? (eg in documented procedures, organisation charts, positions descriptions)\nAre the organisation charts up to date and do the positions outlined in procedures appear on the organisation chart?   Does every position on the organisation chart have a correlating position description?"}
                                                            auditFinding={state.finding11}
                                                            auditFindingName={"finding11"}
                                                            evidenceViewed={state.evidence11}
                                                            evidenceViewedName={"evidence11"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"12"}
                                                            iso9001={"5.3"}
                                                            iso14001={"5.3"}
                                                            iso45001={"5.3"}
                                                            qualityRequirement={"Define authorities and responsibilities of personnel permitted to access, enter, change IMS data.\n" +
                                                            "Authorise release of results and reports"}
                                                            auditFinding={state.finding13}
                                                            auditFindingName={"finding13"}
                                                            evidenceViewed={state.evidence13}
                                                            evidenceViewedName={"evidence13"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"13"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"5.4"}
                                                            qualityRequirement={"Is there evidence workers have been consulted and participated in the development of OHS issues, eg, policy, objectives, risk assessment, incident investigations?  An example of this consultative process could be toolbox meetings/staff meetings etc"}
                                                            auditFinding={state.finding14}
                                                            auditFindingName={"finding14"}
                                                            evidenceViewed={state.evidence14}
                                                            evidenceViewedName={"evidence14"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"14"}
                                                            iso9001={"4.4.1\n5.1.1"}
                                                            iso14001={"5.1"}
                                                            iso45001={"5.1"}
                                                            qualityRequirement={"Are there appropriate resources to support the IMS (eg organisational structure, software, hardware, equipment, specialist knowledge)?"}
                                                            auditFinding={state.finding15}
                                                            auditFindingName={"finding15"}
                                                            evidenceViewed={state.evidence15}
                                                            evidenceViewedName={"evidence15"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"15"}
                                                            iso9001={"7.3\n7.4\n5.1.1"}
                                                            iso14001={"7.3\n7.4\n5.1"}
                                                            iso45001={"7.3\n7.4\n5.1"}
                                                            qualityRequirement={"Are issues related to the IMS being communicated effectively, what, how, who, when etc \nAre staff/contractors aware of IMS requirements, legal responsibilities, risks and hazards?  If the organisation has a Communication Plan has it been implemented?"}
                                                            auditFinding={state.finding16}
                                                            auditFindingName={"finding16"}
                                                            evidenceViewed={state.evidence16}
                                                            evidenceViewedName={"evidence16"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"16"}
                                                            iso9001={"5.1.2\n8.2"}
                                                            iso14001={"6.1.3\n9.1.2"}
                                                            iso45001={"6.1.3\n6.1.4\n9.1.2"}
                                                            qualityRequirement={"Are IMS compliance obligations, including statutory and regulatory requirements identified and fulfilled, and where applicable, mechanisms for compliance with the obligations are incorporated into the IMS? (eg procedures, processes, risk analysis, staff training etc)? How does the organisation keep abreast of changes in compliance requirements?"}
                                                            auditFinding={state.finding17}
                                                            auditFindingName={"finding17"}
                                                            evidenceViewed={state.evidence17}
                                                            evidenceViewedName={"evidence17"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"17"}
                                                            iso9001={"6.3\n5.3\n5.1.1"}
                                                            iso14001={"8.1"}
                                                            iso45001={"6.1.2.1g\n8.1.3\n8.2"}
                                                            qualityRequirement={"Have there been any major changes at the organisation? If yes, how have these changes been managed?"}
                                                            auditFinding={state.finding18}
                                                            auditFindingName={"finding18"}
                                                            evidenceViewed={state.evidence18}
                                                            evidenceViewedName={"evidence18"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"18"}
                                                            iso9001={"7.1.6"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is there any evidence of the following:\n- lessons learned?\n- participation / attendance in industry conferences?\n- staff  training?"}
                                                            auditFinding={state.finding19}
                                                            auditFindingName={"finding19"}
                                                            evidenceViewed={state.evidence19}
                                                            evidenceViewedName={"evidence19"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"19"}
                                                            iso9001={"10.3"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"If the organisation conducts testing is the testing and calibration conducted onsite? Are the environmental conditions controlled in accordance with any specified criteria?"}
                                                            auditFinding={state.finding20}
                                                            auditFindingName={"finding20"}
                                                            evidenceViewed={state.evidence20}
                                                            evidenceViewedName={"evidence20"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"20"}
                                                            header={"IMS POLICY"}
                                                            iso9001={"5.1.1\n5.2.1"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Has the IMS policy been authorised by a person in the organisation with approrpaite delegated authority?"}
                                                            auditFinding={state.finding21}
                                                            auditFindingName={"finding21"}
                                                            evidenceViewed={state.evidence21}
                                                            evidenceViewedName={"evidence21"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"21"}
                                                            iso9001={"5.1.1\n5.2.1"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Is there evidence of review of the IMS Policy (eg revision, date authorised, name of the signatory as per organisational delegated authority requirements)"}
                                                            auditFinding={state.finding22}
                                                            auditFindingName={"finding22"}
                                                            evidenceViewed={state.evidence22}
                                                            evidenceViewedName={"evidence22"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"22"}
                                                            iso9001={"5.2.1"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Is the IMS policy relevant and appropriate to the business and supports its strategic direction?"}
                                                            auditFinding={state.finding23}
                                                            auditFindingName={"finding23"}
                                                            evidenceViewed={state.evidence23}
                                                            evidenceViewedName={"evidence23"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"23"}
                                                            iso9001={"5.2.1"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Does the IMS Policy provide a framework for establishing objectives?"}
                                                            auditFinding={state.finding24}
                                                            auditFindingName={"finding24"}
                                                            evidenceViewed={state.evidence24}
                                                            evidenceViewedName={"evidence24"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"24"}
                                                            iso9001={"5.2.1"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Does the IMS Policy include a commitment to comply with applicable requirements and regulations?"}
                                                            auditFinding={state.finding25}
                                                            auditFindingName={"finding25"}
                                                            evidenceViewed={state.evidence25}
                                                            evidenceViewedName={"evidence25"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"25"}
                                                            iso9001={"5.2.1"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Does the IMS Policy include a commitment for continual improvement?"}
                                                            auditFinding={state.finding26}
                                                            auditFindingName={"finding26"}
                                                            evidenceViewed={state.evidence26}
                                                            evidenceViewedName={"evidence26"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"26"}
                                                            iso9001={"5.2.2"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Is the IMS policy communicated to and understood by all staff?"}
                                                            auditFinding={state.finding27}
                                                            auditFindingName={"finding27"}
                                                            evidenceViewed={state.evidence27}
                                                            evidenceViewedName={"evidence27"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"27"}
                                                            iso9001={"5.2.2"}
                                                            iso14001={"5.2"}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Is the IMS Policy readily available to interested parties?"}
                                                            auditFinding={state.finding28}
                                                            auditFindingName={"finding28"}
                                                            evidenceViewed={state.evidence28}
                                                            evidenceViewedName={"evidence28"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"28"}
                                                            iso9001={""}
                                                            iso14001={"5.2"}
                                                            iso45001={""}
                                                            qualityRequirement={"Does the IMS Policy contain a commitment to protection of the environment and prevention of pollution?"}
                                                            auditFinding={state.finding29}
                                                            auditFindingName={"finding29"}
                                                            evidenceViewed={state.evidence29}
                                                            evidenceViewedName={"evidence29"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"29"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Does the IMS Policy contain a commitment to provide a safe and healthy working conditions?"}
                                                            auditFinding={state.finding30}
                                                            auditFindingName={"finding30"}
                                                            evidenceViewed={state.evidence30}
                                                            evidenceViewedName={"evidence30"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"30"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Does the IMS Policy contain a commitment to eliminate hazards and reduce OH&S risks?"}
                                                            auditFinding={state.finding31}
                                                            auditFindingName={"finding31"}
                                                            evidenceViewed={state.evidence31}
                                                            evidenceViewedName={"evidence31"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"31"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"5.2"}
                                                            qualityRequirement={"Does the IMS Policy contain a commitment to consultation and participation of workers?"}
                                                            auditFinding={state.finding32}
                                                            auditFindingName={"finding32"}
                                                            evidenceViewed={state.evidence32}
                                                            evidenceViewedName={"evidence32"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"32"}
                                                            header={"IMS OBJECTIVES"}
                                                            iso9001={"5.1.1\n6.2.1"}
                                                            iso14001={"5.1\n6.2.1"}
                                                            iso45001={"5.1\n6.2.1"}
                                                            qualityRequirement={"Are there objectives and targets set to support the IMS objectives?"}
                                                            auditFinding={state.finding33}
                                                            auditFindingName={"finding33"}
                                                            evidenceViewed={state.evidence33}
                                                            evidenceViewedName={"evidence33"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"33"}
                                                            iso9001={"6.2.1"}
                                                            iso14001={"6.2.1"}
                                                            iso45001={"6.2.1"}
                                                            qualityRequirement={"Are they consistent with the IMS Policy?"}
                                                            auditFinding={state.finding34}
                                                            auditFindingName={"finding34"}
                                                            evidenceViewed={state.evidence34}
                                                            evidenceViewedName={"evidence34"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"34"}
                                                            iso9001={"6.2.1"}
                                                            iso14001={"6.2.1"}
                                                            iso45001={"6.2.1"}
                                                            qualityRequirement={"Are the targets measurable (i.e. quantitative not just qualitative)?"}
                                                            auditFinding={state.finding35}
                                                            auditFindingName={"finding35"}
                                                            evidenceViewed={state.evidence35}
                                                            evidenceViewedName={"evidence35"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"35"}
                                                            iso9001={"5.1.1\n6.2.1"}
                                                            iso14001={"5.1\n6.2.1"}
                                                            iso45001={"6.2.1"}
                                                            qualityRequirement={"Are they established, communicated and reviewed periodically by senior management?"}
                                                            auditFinding={state.finding36}
                                                            auditFindingName={"finding36"}
                                                            evidenceViewed={state.evidence36}
                                                            evidenceViewedName={"evidence36"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"36"}
                                                            iso9001={"5.1.1\n6.2.2"}
                                                            iso14001={"5.1\n6.2.2"}
                                                            iso45001={"3.2.2"}
                                                            qualityRequirement={"Is there a plan in place which identifies what is required, the resources required, responsibility, completion dates and method of evaluation?"}
                                                            auditFinding={state.finding37}
                                                            auditFindingName={"finding37"}
                                                            evidenceViewed={state.evidence37}
                                                            evidenceViewedName={"evidence37"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"37"}
                                                            header={"MANAGEMENT REVIEW"}
                                                            iso9001={"9.3.1\n5.1.1"}
                                                            iso14001={"9.3"}
                                                            iso45001={"9.3"}
                                                            qualityRequirement={"Are management review meetings conducted annually as a minimum?"}
                                                            auditFinding={state.finding38}
                                                            auditFindingName={"finding38"}
                                                            evidenceViewed={state.evidence38}
                                                            evidenceViewedName={"evidence38"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"38"}
                                                            iso9001={"9.3.2"}
                                                            iso14001={"9.3"}
                                                            iso45001={"9.3"}
                                                            qualityRequirement={"Does the Management Review agenda include all agenda items as per standard requirements?"}
                                                            auditFinding={state.finding39}
                                                            auditFindingName={"finding39"}
                                                            evidenceViewed={state.evidence39}
                                                            evidenceViewedName={"evidence39"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"39"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Does the review include analysis of causes of nonconformances, trend and pattern that indicate process/systemic problems?"}
                                                            auditFinding={state.finding40}
                                                            auditFindingName={"finding40"}
                                                            evidenceViewed={state.evidence40}
                                                            evidenceViewedName={"evidence40"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"40"}
                                                            iso9001={"9.3.3"}
                                                            iso14001={"9.3"}
                                                            iso45001={"9.3"}
                                                            qualityRequirement={"Are approved minutes available from the meeting and distributed to relevant personnel?"}
                                                            auditFinding={state.finding41}
                                                            auditFindingName={"finding41"}
                                                            evidenceViewed={state.evidence41}
                                                            evidenceViewedName={"evidence41"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"41"}
                                                            iso9001={"9.3.3"}
                                                            iso14001={"9.3"}
                                                            iso45001={"9.3"}
                                                            qualityRequirement={"Are actions assigned and being completed in an acceptable timeframe?"}
                                                            auditFinding={state.finding42}
                                                            auditFindingName={"finding42"}
                                                            evidenceViewed={state.evidence42}
                                                            evidenceViewedName={"evidence42"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"42"}
                                                            header={"INTERNAL AUDIT"}
                                                            iso9001={"9.2.2"}
                                                            iso14001={"9.2.2"}
                                                            iso45001={"9.2.2"}
                                                            qualityRequirement={"Is there an internal audit procedure?\nIs there an audit schedule available?    Was the internal audit conducted in accordance with the internal audit schedule?"}
                                                            auditFinding={state.finding43}
                                                            auditFindingName={"finding43"}
                                                            evidenceViewed={state.evidence43}
                                                            evidenceViewedName={"evidence43"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"43"}
                                                            iso9001={"9.2.2"}
                                                            iso14001={"9.2.2"}
                                                            iso45001={"9.2.2"}
                                                            qualityRequirement={"Is the audit schedule based on criticality of process, risk to business area and previous audit findings?"}
                                                            auditFinding={state.finding44}
                                                            auditFindingName={"finding44"}
                                                            evidenceViewed={state.evidence44}
                                                            evidenceViewedName={"evidence44"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"44"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are all operational procedures reviewed regularly? Are opportunities for improvement identified and plans for improvement implemented?"}
                                                            auditFinding={state.finding45}
                                                            auditFindingName={"finding45"}
                                                            evidenceViewed={state.evidence45}
                                                            evidenceViewedName={"evidence45"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"45"}
                                                            iso9001={"9.2.1"}
                                                            iso14001={"9.2.1"}
                                                            iso45001={"9.2.2"}
                                                            qualityRequirement={"Was the previous audit schedule completed?  Did it cover all elements of the IMS?"}
                                                            auditFinding={state.finding46}
                                                            auditFindingName={"finding46"}
                                                            evidenceViewed={state.evidence46}
                                                            evidenceViewedName={"evidence46"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"46"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is periodic review of examinations being conducted, ie correct sample volume, collection device, preservation requirements to ensure integrity of sample"}
                                                            auditFinding={state.finding47}
                                                            auditFindingName={"finding47"}
                                                            evidenceViewed={state.evidence47}
                                                            evidenceViewedName={"evidence47"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"47"}
                                                            iso9001={"9.2.2"}
                                                            iso14001={"9.2.2"}
                                                            iso45001={"9.2.2"}
                                                            qualityRequirement={"Is each audit allocated an audit number and an audit report available?"}
                                                            auditFinding={state.finding48}
                                                            auditFindingName={"finding48"}
                                                            evidenceViewed={state.evidence48}
                                                            evidenceViewedName={"evidence48"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"48"}
                                                            iso9001={"9.2.2"}
                                                            iso14001={"9.2.2"}
                                                            iso45001={"9.2.2"}
                                                            qualityRequirement={"Was the auditor objective and impartial (ie not involved in the process or activity being audited?).   Need to verify that the auditors were independent from the task being audited."}
                                                            auditFinding={state.finding49}
                                                            auditFindingName={"finding49"}
                                                            evidenceViewed={state.evidence49}
                                                            evidenceViewedName={"evidence49"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"49"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is there evidence of training for auditors?  Verify that internal auditors have conducted internal auditor training."}
                                                            auditFinding={state.finding50}
                                                            auditFindingName={"finding50"}
                                                            evidenceViewed={state.evidence50}
                                                            evidenceViewedName={"evidence50"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"50"}
                                                            iso9001={"9.2.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have non-conformances registered in the NCR/CAR system?"}
                                                            auditFinding={state.finding51}
                                                            auditFindingName={"finding51"}
                                                            evidenceViewed={state.evidence51}
                                                            evidenceViewedName={"evidence51"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"51"}
                                                            header={"NONCONFORMANCE"}
                                                            iso9001={"8.7.1\n10.2.1"}
                                                            iso14001={"10.2"}
                                                            iso45001={"10.2"}
                                                            qualityRequirement={"Is the NCR/CAR process being utilised effectively, eg used to record non-conforming outputs (product defects, service, contract deliverables etc), customer complaints, HSE incidents, audit findings, workplace inspections, supplier issues etc."}
                                                            auditFinding={state.finding52}
                                                            auditFindingName={"finding52"}
                                                            evidenceViewed={state.evidence52}
                                                            evidenceViewedName={"evidence52"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"52"}
                                                            iso9001={"8.7.1 \n8.7.2\n10.2.1\n10.2.2"}
                                                            iso14001={"10.2"}
                                                            iso45001={"10.2"}
                                                            qualityRequirement={"Is the NCR/CAR register being maintained?"}
                                                            auditFinding={state.finding53}
                                                            auditFindingName={"finding53"}
                                                            evidenceViewed={state.evidence53}
                                                            evidenceViewedName={"evidence53"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"53"}
                                                            iso9001={"10.2.1"}
                                                            iso14001={"10.2"}
                                                            iso45001={"10.2"}
                                                            qualityRequirement={"Does assessment of the issue determine if a similar issue exists or could potentially occur?"}
                                                            auditFinding={state.finding54}
                                                            auditFindingName={"finding54"}
                                                            evidenceViewed={state.evidence54}
                                                            evidenceViewedName={"evidence54"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"54"}
                                                            iso9001={"10.2.1"}
                                                            iso14001={"10.2"}
                                                            iso45001={"7.3\n10.2"}
                                                            qualityRequirement={"Are results of investigation communicated and corrective actions being implemented?"}
                                                            auditFinding={state.finding55}
                                                            auditFindingName={"finding55"}
                                                            evidenceViewed={state.evidence55}
                                                            evidenceViewedName={"evidence55"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"55"}
                                                            iso9001={"10.2.1"}
                                                            iso14001={"10.2"}
                                                            iso45001={"10.2"}
                                                            qualityRequirement={"Are corrective actions assessed prior to the NCR/CAR being closed?"}
                                                            auditFinding={state.finding56}
                                                            auditFindingName={"finding56"}
                                                            evidenceViewed={state.evidence56}
                                                            evidenceViewedName={"evidence56"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"56"}
                                                            iso9001={"10.2.2"}
                                                            iso14001={"10.2"}
                                                            iso45001={"10.2"}
                                                            qualityRequirement={"Are records available to document the issue, investigation, identification of root cause (where  applicable), corrective action implemented and effective closure of the issue?"}
                                                            auditFinding={state.finding57}
                                                            auditFindingName={"finding57"}
                                                            evidenceViewed={state.evidence57}
                                                            evidenceViewedName={"evidence57"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"57"}
                                                            header={"CUSTOMER FEEDBACK"}
                                                            iso9001={"9.1.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are customer feedback records available?"}
                                                            auditFinding={state.finding59}
                                                            auditFindingName={"finding59"}
                                                            evidenceViewed={state.evidence59}
                                                            evidenceViewedName={"evidence59"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"58"}
                                                            iso9001={"9.1.3"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is appropriate action being taken as a result of feedback?"}
                                                            auditFinding={state.finding60}
                                                            auditFindingName={"finding60"}
                                                            evidenceViewed={state.evidence60}
                                                            evidenceViewedName={"evidence60"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"59"}
                                                            header={"DOCUMENTED INFORMATION"}
                                                            iso9001={"7.5.2"}
                                                            iso14001={"7.5.2"}
                                                            iso45001={"7.5.2"}
                                                            qualityRequirement={"Have all controlled documents reviewed during the audit been approved by authorised personnel? Title, rev, page no etc"}
                                                            auditFinding={state.finding64}
                                                            auditFindingName={"finding64"}
                                                            evidenceViewed={state.evidence64}
                                                            evidenceViewedName={"evidence64"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"60"}
                                                            iso9001={"7.5.3.1"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Are controlled documents available for use where needed?"}
                                                            auditFinding={state.finding65}
                                                            auditFindingName={"finding65"}
                                                            evidenceViewed={state.evidence65}
                                                            evidenceViewedName={"evidence65"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"61"}
                                                            iso9001={"7.5.3.1"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Is documented information adequately protected from loss of confidentiality, unauthorised use or change, have version control.  (eg password log-ins, locked spreadsheets, read only access)"}
                                                            auditFinding={state.finding66}
                                                            auditFindingName={"finding66"}
                                                            evidenceViewed={state.evidence66}
                                                            evidenceViewedName={"evidence66"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"62"}
                                                            iso9001={"7.5.3.1"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Is routine back up of the server occurring?  Have these back up procedures been documented?"}
                                                            auditFinding={state.finding67}
                                                            auditFindingName={"finding67"}
                                                            evidenceViewed={state.evidence67}
                                                            evidenceViewedName={"evidence67"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"63"}
                                                            iso9001={"7.5.3.1"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Are external test methods and specifications available and current?"}
                                                            auditFinding={state.finding68}
                                                            auditFindingName={"finding68"}
                                                            evidenceViewed={state.evidence68}
                                                            evidenceViewedName={"evidence68"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"64"}
                                                            iso9001={"7.5.3.2"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Are all controlled documents reviewed during the audit current and included in the Master Document Register?"}
                                                            auditFinding={state.finding69}
                                                            auditFindingName={"finding69"}
                                                            evidenceViewed={state.evidence69}
                                                            evidenceViewedName={"evidence69"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"65"}
                                                            iso9001={"7.5.3.2"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Are superseded documents identified or segregated from current versions?"}
                                                            auditFinding={state.finding70}
                                                            auditFindingName={"finding70"}
                                                            evidenceViewed={state.evidence70}
                                                            evidenceViewedName={"evidence70"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"66"}
                                                            iso9001={"8.5.3.2"}
                                                            iso14001={"7.5.3"}
                                                            iso45001={"7.5.3"}
                                                            qualityRequirement={"Are  records retained (for a minimum of 4 years), suitably identified and stored in a safe and secure location?  Are they readily retrievable?"}
                                                            auditFinding={state.finding71}
                                                            auditFindingName={"finding71"}
                                                            evidenceViewed={state.evidence71}
                                                            evidenceViewedName={"evidence71"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"67"}
                                                            iso9001={"7.5.3.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are quality and technical records maintained and stored in correct locations, eg project files, hard copies?"}
                                                            auditFinding={state.finding72}
                                                            auditFindingName={"finding72"}
                                                            evidenceViewed={state.evidence72}
                                                            evidenceViewedName={"evidence72"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"68"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Do test and calibration records identify the person who completed the record and date?"}
                                                            auditFinding={state.finding73}
                                                            auditFindingName={"finding73"}
                                                            evidenceViewed={state.evidence73}
                                                            evidenceViewedName={"evidence73"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"69"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have any corrections or changes to records identified, initilled and dated?"}
                                                            auditFinding={state.finding74}
                                                            auditFindingName={"finding74"}
                                                            evidenceViewed={state.evidence74}
                                                            evidenceViewedName={"evidence74"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"70"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"The information system management is controlled per 5.19.3 (validated, protected, available, maintained, meets data protection requirements"}
                                                            auditFinding={state.finding75}
                                                            auditFindingName={"finding75"}
                                                            evidenceViewed={state.evidence75}
                                                            evidenceViewedName={"evidence75"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"71"}
                                                            header={"MONITORING, MEASUREMENT AND ANALYSIS"}
                                                            iso9001={"9.1"}
                                                            iso14001={"9.1.2"}
                                                            iso45001={"9.1.2"}
                                                            qualityRequirement={"Monitoring, measurement and analysis has been defined e.g.\n" +
                                                            "- Product /service acceptance criteria has been assessed?\n" +
                                                            "- Training completed as per nominated training programs.  Training identified during performance assessments have been completed?\n" +
                                                            "- NCR/CAR's being completed within the required timeframe? Internal audits have been completed in accordance with the Internal audit schedule?\n" +
                                                            "-  Assessment condcuted on the level of legal compliance?"}
                                                            auditFinding={state.finding76}
                                                            auditFindingName={"finding76"}
                                                            evidenceViewed={state.evidence76}
                                                            evidenceViewedName={"evidence76"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"72"}
                                                            header={"INFRASTRUCTURE AND FACILITIES"}
                                                            iso9001={"7.1.3"}
                                                            iso14001={"7.1"}
                                                            iso45001={"7.1"}
                                                            qualityRequirement={"Is the infrastructure adequate for achieving the conformity of products and services, compliance to regulations and implementation of the IMS?, eg buildings, equipment, test and calibration facilities, sample storage, IT and communication facilities, controlled access\n" +
                                                            "15189 - facilities designed to ensure health and safety of people."}
                                                            auditFinding={state.finding77}
                                                            auditFindingName={"finding77"}
                                                            evidenceViewed={state.evidence77}
                                                            evidenceViewedName={"evidence77"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"73"}
                                                            iso9001={"7.1.4"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are specific requirements for processes conducted in specific environment conditions in order to achieve conformity of product or process?  If so are they being controlled within the required tolerances? eg temperature, humidity, light.  Are records maintained?"}
                                                            auditFinding={state.finding78}
                                                            auditFindingName={"finding78"}
                                                            evidenceViewed={state.evidence78}
                                                            evidenceViewedName={"evidence78"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"74"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"If testing and calibration are conducted on-site, are the environmental conditions controlled in accordance with any specified criteria?"}
                                                            auditFinding={state.finding79}
                                                            auditFindingName={"finding79"}
                                                            evidenceViewed={state.evidence79}
                                                            evidenceViewedName={"evidence79"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"75"}
                                                            header={"PURCHASING AND SUPPLIER APPROVAL"}
                                                            iso9001={"8.4.1"}
                                                            iso14001={""}
                                                            iso45001={"8.4.1.3"}
                                                            qualityRequirement={"Has the organisation devloped and implemented an Approved Supplier list / Approved Subcontractor list?"}
                                                            auditFinding={state.finding81}
                                                            auditFindingName={"finding81"}
                                                            evidenceViewed={state.evidence81}
                                                            evidenceViewedName={"evidence81"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"76"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Verify that suppliers nominated on the Chemical Register also appear on the Approved Supplier list?"}
                                                            auditFinding={state.finding82}
                                                            auditFindingName={"finding82"}
                                                            evidenceViewed={state.evidence82}
                                                            evidenceViewedName={"evidence82"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"77"}
                                                            iso9001={"8.4.3"}
                                                            iso14001={""}
                                                            iso45001={"8.4"}
                                                            qualityRequirement={"Did purchase orders contain all relevant information for the external provided to fulfill the requirements, including acceptance criteria where applicable?\n" +
                                                            "Were any specific OHS controls communicated to the supplier?"}
                                                            auditFinding={state.finding83}
                                                            auditFindingName={"finding83"}
                                                            evidenceViewed={state.evidence83}
                                                            evidenceViewedName={"evidence83"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"78"}
                                                            iso9001={"8.4.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are all goods and services received verified against the original purchase requirements?\n" +
                                                            "Are any quality control verifications conducted on supplies as required?"}
                                                            auditFinding={state.finding84}
                                                            auditFindingName={"finding84"}
                                                            evidenceViewed={state.evidence84}
                                                            evidenceViewedName={"evidence84"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"79"}
                                                            iso9001={"7.5.1"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are records maintained as per documented processes?"}
                                                            auditFinding={state.finding85}
                                                            auditFindingName={"finding85"}
                                                            evidenceViewed={state.evidence85}
                                                            evidenceViewedName={"evidence85"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"80"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have any tests or calibrations included in the Scope of Accreditation been subcontracted to facilities accredited for that activity?  Are there records of their accreditation been retained? Was the use of an external provided communicated to and accepted by the customer?"}
                                                            auditFinding={state.finding86}
                                                            auditFindingName={"finding86"}
                                                            evidenceViewed={state.evidence86}
                                                            evidenceViewedName={"evidence86"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"81"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"8.5"}
                                                            qualityRequirement={"Controls and communication requirements with regard to contractor’s worker activities, the host company’s worker activities, and anyone who may be affected by the activity in the workplace."}
                                                            auditFinding={state.finding87}
                                                            auditFindingName={"finding87"}
                                                            evidenceViewed={state.evidence87}
                                                            evidenceViewedName={"evidence87"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"82"}
                                                            iso9001={""}
                                                            iso14001={"8.1"}
                                                            iso45001={""}
                                                            qualityRequirement={"Have any specific environmental requirements been identified and communicated to external providers including contractors?"}
                                                            auditFinding={state.finding88}
                                                            auditFindingName={"finding88"}
                                                            evidenceViewed={state.evidence88}
                                                            evidenceViewedName={"evidence88"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"83"}
                                                            iso9001={""}
                                                            iso14001={"7.3\n7.4"}
                                                            iso45001={""}
                                                            qualityRequirement={"Have any required site specific environmental controls been identified and communication to applicable personnel.  Are they being adhered to?"}
                                                            auditFinding={state.finding89}
                                                            auditFindingName={"finding89"}
                                                            evidenceViewed={state.evidence89}
                                                            evidenceViewedName={"evidence89"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"84"}
                                                            header={"COMPETENCY ANALYSIS"}
                                                            iso9001={"7.2"}
                                                            iso14001={"7.2"}
                                                            iso45001={"7.2"}
                                                            qualityRequirement={"Is there evidence  that necessary competencies for personnel have been determined? eg Training Matrix/job descriptions?"}
                                                            auditFinding={state.finding90}
                                                            auditFindingName={"finding90"}
                                                            evidenceViewed={state.evidence90}
                                                            evidenceViewedName={"evidence90"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"85"}
                                                            iso9001={"7.2"}
                                                            iso14001={"7.2"}
                                                            iso45001={"7.2"}
                                                            qualityRequirement={"Have personnel been deemed competent via the documented orgasional processes or external training?\n" +
                                                            "Are documented authorisations in place for personnel covering all significant lab activities, eg sampling, booking in, conducting tests/calibrations, use of equipment and (including for 15189, acces to computer systems and patient data)\n" +
                                                            "Is the competence of personnel reviewed periodically?"}
                                                            auditFinding={state.finding91}
                                                            auditFindingName={"finding91"}
                                                            evidenceViewed={state.evidence91}
                                                            evidenceViewedName={"evidence91"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"86"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have personnel responsible for the testing and calibration activities been identified?"}
                                                            auditFinding={state.finding92}
                                                            auditFindingName={"finding92"}
                                                            evidenceViewed={state.evidence92}
                                                            evidenceViewedName={"evidence92"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"87"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are personnel making professional judgements suitably qualified/experienced\n" +
                                                            "Do personnel take part in regular professional development?"}
                                                            auditFinding={state.finding93}
                                                            auditFindingName={"finding93"}
                                                            evidenceViewed={state.evidence93}
                                                            evidenceViewedName={"evidence93"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"88"}
                                                            iso9001={"7.2"}
                                                            iso14001={"7.2"}
                                                            iso45001={"7.2"}
                                                            qualityRequirement={"Are training records maintained and available?"}
                                                            auditFinding={state.finding94}
                                                            auditFindingName={"finding94"}
                                                            evidenceViewed={state.evidence94}
                                                            evidenceViewedName={"evidence94"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"89"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have personnel been inducted into the organisation?"}
                                                            auditFinding={state.finding95}
                                                            auditFindingName={"finding95"}
                                                            evidenceViewed={state.evidence95}
                                                            evidenceViewedName={"evidence95"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"90"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are documented position descriptions available? Do these position descriptions correlate with nominated positions on the organisation chart."}
                                                            auditFinding={state.finding96}
                                                            auditFindingName={"finding96"}
                                                            evidenceViewed={state.evidence96}
                                                            evidenceViewedName={"evidence96"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"91"}
                                                            iso9001={""}
                                                            iso14001={"7.2"}
                                                            iso45001={""}
                                                            qualityRequirement={"Are there any specific environmental training required completed by applicable personnel?"}
                                                            auditFinding={state.finding97}
                                                            auditFindingName={"finding97"}
                                                            evidenceViewed={state.evidence97}
                                                            evidenceViewedName={"evidence97"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"92"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"7.2"}
                                                            qualityRequirement={"Is there evidence that those involved in HSE hazard identification and/or emergency procedures have been trained?  Is the training current?, eg first aid, fire wardens."}
                                                            auditFinding={state.finding98}
                                                            auditFindingName={"finding98"}
                                                            evidenceViewed={state.evidence98}
                                                            evidenceViewedName={"evidence98"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"93"}
                                                            header={"MEASURING EQUIPMENT"}
                                                            iso9001={"7.1.5.1"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is measuring equipment used identifiable?, eg by Asset Number, Serial Number and the calibration status shown (where possible)"}
                                                            auditFinding={state.finding99}
                                                            auditFindingName={"finding99"}
                                                            evidenceViewed={state.evidence99}
                                                            evidenceViewedName={"evidence99"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"94"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is equipment logged in an equipment and calibration schedule?"}
                                                            auditFinding={state.finding100}
                                                            auditFindingName={"finding100"}
                                                            evidenceViewed={state.evidence100}
                                                            evidenceViewedName={"evidence100"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"95"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are equipment records maintained? Eg model, serial no, current locations and allocation, reference to reference materials during equipment checks, historical information?"}
                                                            auditFinding={state.finding101}
                                                            auditFindingName={"finding101"}
                                                            evidenceViewed={state.evidence101}
                                                            evidenceViewedName={"evidence101"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"96"}
                                                            iso9001={"7.1.5.1"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is the measuring equipment suitable for the type of measurement being undertaken, eg did it adequately cover the range/scale, have the required accuracies?\n" +
                                                            "Has any software been validated, protected from unauthorised changes?"}
                                                            auditFinding={state.finding102}
                                                            auditFindingName={"finding102"}
                                                            evidenceViewed={state.evidence102}
                                                            evidenceViewedName={"evidence102"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"97"}
                                                            iso9001={"7.1.5.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is measuring equipment used calibrated? (Is there a Calibration certificate available and covers the time period the item of equipment was actually used?)"}
                                                            auditFinding={state.finding103}
                                                            auditFindingName={"finding103"}
                                                            evidenceViewed={state.evidence103}
                                                            evidenceViewedName={"evidence103"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"98"}
                                                            iso9001={"7.1.5.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is the calibration certificate traceable to national standards?"}
                                                            auditFinding={state.finding104}
                                                            auditFindingName={"finding104"}
                                                            evidenceViewed={state.evidence104}
                                                            evidenceViewedName={"evidence104"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"99"}
                                                            iso9001={"7.1.5.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are any in-house verification checks being conducted and if so are they being \n" +
                                                            "- recorded\n" +
                                                            "- being conducted at the required frequency at the stated frequency?\n" +
                                                            "- being conducted by competent personnel?"}
                                                            auditFinding={state.finding105}
                                                            auditFindingName={"finding105"}
                                                            evidenceViewed={state.evidence105}
                                                            evidenceViewedName={"evidence105"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"100"}
                                                            iso9001={"7.1.5.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are any in-house verification checks being verified against reference materials calibrated and traceable to national standards?"}
                                                            auditFinding={state.finding106}
                                                            auditFindingName={"finding106"}
                                                            evidenceViewed={state.evidence106}
                                                            evidenceViewedName={"evidence106"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"101"}
                                                            iso9001={"7.1.5.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is measuring equipment adequately stored, handled, protected?\n" +
                                                            "Used by trained personnel?\n" +
                                                            "Is measuring checked prior to use?"}
                                                            auditFinding={state.finding107}
                                                            auditFindingName={"finding107"}
                                                            evidenceViewed={state.evidence107}
                                                            evidenceViewedName={"evidence107"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"102"}
                                                            iso9001={"7.1.5.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are there any items of equipment damaged or out of service and it is appropriately tagged or segregated i.e. Is there a quarantine section?\n" +
                                                            "Is there a process for controlling non-conforming equipment?"}
                                                            auditFinding={state.finding108}
                                                            auditFindingName={"finding108"}
                                                            evidenceViewed={state.evidence108}
                                                            evidenceViewedName={"evidence108"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"103"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are correction factors stated on calibration certificates applied to the test/calibration result (where applicable)?"}
                                                            auditFinding={state.finding109}
                                                            auditFindingName={"finding109"}
                                                            evidenceViewed={state.evidence109}
                                                            evidenceViewedName={"evidence109"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"104"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Documented procedure for the reception, storage, acceptance testing and inventory of reagents and consumables.\n" +
                                                            "Instructions for use\n" +
                                                            "Adverse incidents and accidents - reported to manufacturer\n" +
                                                            "Records maintained"}
                                                            auditFinding={state.finding110}
                                                            auditFindingName={"finding110"}
                                                            evidenceViewed={state.evidence110}
                                                            evidenceViewedName={"evidence110"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"105"}
                                                            header={"CUSTOMER REQUIREMENTS"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is there evidence of adequate contract review conducted by authorised personnel?"}
                                                            auditFinding={state.finding111}
                                                            auditFindingName={"finding111"}
                                                            evidenceViewed={state.evidence111}
                                                            evidenceViewedName={"evidence111"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"106"}
                                                            iso9001={"8.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are customer requirements documented and filed ?  Are copies of executed contracts readily available?"}
                                                            auditFinding={state.finding112}
                                                            auditFindingName={"finding112"}
                                                            evidenceViewed={state.evidence112}
                                                            evidenceViewedName={"evidence112"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"107"}
                                                            iso9001={""}
                                                            iso14001={"4.2\n6.1.1"}
                                                            iso45001={""}
                                                            qualityRequirement={"Have any specific environmental considerations specified by the customer/state/shire etc been identified and the required controls implemented?, eg quarantine processes, cleaning and decontamination."}
                                                            auditFinding={state.finding113}
                                                            auditFindingName={"finding113"}
                                                            evidenceViewed={state.evidence113}
                                                            evidenceViewedName={"evidence113"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"108"}
                                                            iso9001={"8.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Document and data control is consistently applied across projects?"}
                                                            auditFinding={state.finding114}
                                                            auditFindingName={"finding114"}
                                                            evidenceViewed={state.evidence114}
                                                            evidenceViewedName={"evidence114"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"109"}
                                                            iso9001={"8.2.3.1\n8.2.3.2"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are any clarification records maintained and traceable to the job? (eg e-mail trails, revision to PO's).  Was the customer advised of any deviation from their requirements?"}
                                                            auditFinding={state.finding115}
                                                            auditFindingName={"finding115"}
                                                            evidenceViewed={state.evidence115}
                                                            evidenceViewedName={"evidence115"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"110"}
                                                            iso9001={"8.2.3.1"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is the details on the customer purchase order reviewed against the quotation?"}
                                                            auditFinding={state.finding116}
                                                            auditFindingName={"finding116"}
                                                            evidenceViewed={state.evidence116}
                                                            evidenceViewedName={"evidence116"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"111"}
                                                            iso9001={"8.2.4"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Have any variations to contract been documented, evaluated and agreed with the customer?"}
                                                            auditFinding={state.finding117}
                                                            auditFindingName={"finding117"}
                                                            evidenceViewed={state.evidence117}
                                                            evidenceViewedName={"evidence117"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"112"}
                                                            header={"CONTROL OF PRODUCT/SERVICE"}
                                                            iso9001={"7.5.3\n8.5.1"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Are standard methods, customer specifications, internal procedures, process maps, work instructions, guidance documents, work packs available for the operations being conducted (as applicable)?\n" +
                                                            "\n" +
                                                            "Are they current/latest versions?"}
                                                            auditFinding={state.finding118}
                                                            auditFindingName={"finding118"}
                                                            evidenceViewed={state.evidence118}
                                                            evidenceViewedName={"evidence118"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"113"}
                                                            iso9001={"8.6"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Has compliance of the product or service with requirements been evaluated and recorded prior to release/issue to the customer?"}
                                                            auditFinding={state.finding125}
                                                            auditFindingName={"finding125"}
                                                            evidenceViewed={state.evidence125}
                                                            evidenceViewedName={"evidence125"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"114"}
                                                            iso9001={"8.6"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={"Is there a process in place regarding the release of a product/service?"}
                                                            auditFinding={state.finding126}
                                                            auditFindingName={"finding126"}
                                                            evidenceViewed={state.evidence126}
                                                            evidenceViewedName={"evidence126"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"115"}
                                                            iso9001={"8.7"}
                                                            iso14001={""}
                                                            iso45001={""}
                                                            qualityRequirement={""}
                                                            auditFinding={state.finding128}
                                                            auditFindingName={"finding128"}
                                                            evidenceViewed={state.evidence128}
                                                            evidenceViewedName={"evidence128"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"116"}
                                                            header={"SPECIFIC ENVIRONMENTAL (ISO 14001) and OHS (ISO 45001) REQUIREMENTS"}
                                                            iso9001={""}
                                                            iso14001={"6.1.2\n6.1.4"}
                                                            iso45001={""}
                                                            qualityRequirement={"When determining environmental aspects, does the organisation take into account:\n- change, including planned or new development, and new or modified activities, products and services?\n- abnormal conditions and reasonably foreseeable emergency situations?"}
                                                            auditFinding={state.finding129}
                                                            auditFindingName={"finding129"}
                                                            evidenceViewed={state.evidence129}
                                                            evidenceViewedName={"evidence129"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"117"}
                                                            iso9001={""}
                                                            iso14001={"8.1"}
                                                            iso45001={""}
                                                            qualityRequirement={"Does the organisation ensure that outsourced processes are controlled or influenced?\nAre the type and extent of control(s) applied to the process(es) defined within the management system?"}
                                                            auditFinding={state.finding130}
                                                            auditFindingName={"finding130"}
                                                            evidenceViewed={state.evidence130}
                                                            evidenceViewedName={"evidence130"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"118"}
                                                            iso9001={""}
                                                            iso14001={"8.2"}
                                                            iso45001={""}
                                                            qualityRequirement={"Is there a spill kit available at applicable location(s)?   Are the spill kits empty?"}
                                                            auditFinding={state.finding133}
                                                            auditFindingName={"finding133"}
                                                            evidenceViewed={state.evidence133}
                                                            evidenceViewedName={"evidence133"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"119"}
                                                            iso9001={""}
                                                            iso14001={"8.2"}
                                                            iso45001={""}
                                                            qualityRequirement={"Are controls to prevent/minimise emissions to the environment being used effectively and correctly, e.g. fume extractors, bunding, water recycling, containment of contaminated water, noise barriers?"}
                                                            auditFinding={state.finding134}
                                                            auditFindingName={"finding134"}
                                                            evidenceViewed={state.evidence134}
                                                            evidenceViewedName={"evidence134"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"120"}
                                                            iso9001={""}
                                                            iso14001={"7.4.1\n8.2"}
                                                            iso45001={"7.4.1\n8.6"}
                                                            qualityRequirement={"Is the facility aware of the emergency response plan applicable for their site?"}
                                                            auditFinding={state.finding131}
                                                            auditFindingName={"finding131"}
                                                            evidenceViewed={state.evidence131}
                                                            evidenceViewedName={"evidence131"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"121"}
                                                            iso9001={""}
                                                            iso14001={"8.2"}
                                                            iso45001={"6.1.4"}
                                                            qualityRequirement={"Is there an evacuation diagram available in key areas? (eg exits, meeting rooms, kitchen/communal areas)."}
                                                            auditFinding={state.finding132}
                                                            auditFindingName={"finding132"}
                                                            evidenceViewed={state.evidence132}
                                                            evidenceViewedName={"evidence132"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"122"}
                                                            iso9001={""}
                                                            iso14001={"8.2"}
                                                            iso45001={"8.6"}
                                                            qualityRequirement={"Is there evidence that the emergency response plan is regularly reviewed?"}
                                                            auditFinding={state.finding136}
                                                            auditFindingName={"finding136"}
                                                            evidenceViewed={state.evidence136}
                                                            evidenceViewedName={"evidence136"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"123"}
                                                            iso9001={""}
                                                            iso14001={"8.2"}
                                                            iso45001={"6.1.4\n8.2"}
                                                            qualityRequirement={"Has the emergency response plan been recently tested?  If yes,please include the date and details of the testing."}
                                                            auditFinding={state.finding135}
                                                            auditFindingName={"finding135"}
                                                            evidenceViewed={state.evidence135}
                                                            evidenceViewedName={"evidence135"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"124"}
                                                            iso9001={""}
                                                            iso14001={"8.1"}
                                                            iso45001={"6.1.2.1\n6.1.2.2\n8.1.1\n8.1.2"}
                                                            qualityRequirement={"Are Safe Work Method Statements (SWMS) completed prior to commencing work?  Is the hierarchy of controls applied?"}
                                                            auditFinding={state.finding80}
                                                            auditFindingName={"finding80"}
                                                            evidenceViewed={state.evidence80}
                                                            evidenceViewedName={"evidence80"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"125"}
                                                            iso9001={""}
                                                            iso14001={""}
                                                            iso45001={"6.1.2.1\n6.1.2.2\n8.1.2"}
                                                            qualityRequirement={"Are risk assessments available for the process and/or use of equipment, materials, substances as applicable? Auditor to select random sample to confirm."}
                                                            auditFinding={state.finding137}
                                                            auditFindingName={"finding137"}
                                                            evidenceViewed={state.evidence137}
                                                            evidenceViewedName={"evidence137"}
                                                        />
                                                        <ImsAuditChecklistRow
                                                            onChangeHandler={this.onChange}
                                                            number={"126"}
                                                            iso9001={""}
                                                            iso14001={"8.2"}
                                                            iso45001={"8.2"}
                                                            qualityRequirement={"Are personnel aware of their responsibilities during emergency situations, eg first aiders, fire wardens?"}
                                                            auditFinding={state.finding138}
                                                            auditFindingName={"finding138"}
                                                            evidenceViewed={state.evidence138}
                                                            evidenceViewedName={"evidence138"}
                                                        />
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        <Grid item xs={12}>
                            <GreenButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleTwoTone />}
                                size="small"
                                onClick={this.saveImsAuditChecklist}
                                style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                disabled={isAuditor}
                            >
                                SAVE
                            </GreenButton>
                            {!isDemo && state.id &&
                            <OrangeButton
                                variant="contained"
                                color="secondary"
                                startIcon={<AddCircleTwoTone />}
                                size="small"
                                onClick={() => this.exportSingleReport(state.id)}
                                style={{ marginTop: '20px', marginBottom: '20px', marginLeft: '20px', float: "left" }}
                            >
                                Export
                            </OrangeButton>}
                        </Grid>
                        </React.Fragment>}
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={state.show}
                            onClose={() => this.closeModal(null)}
                        >
                            <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                        </Modal>
                        <NotificationContainer/>
                    </Paper>
            </form>
        </div>
    }
}

export default withStyles(classes)(ImsAuditChecklist);